// Guard against the script being loaded more than once (e.g. Shopify script tag
// injection + manual theme inclusion). Must stay at the top of the file.
if (window.__w3ProductOptionsLoaded) {
    // Already initialized in this page load -- bail out before anything else runs.
} else {
    window.__w3ProductOptionsLoaded = true;

var poScript = document.currentScript;

function getScriptUrlPO() {
     return "https://productoptions.w3apps.co/";
    if (typeof (poScript) != "undefined") {
        return poScript.src;
    } else {
        return "https://productoptions.w3apps.co/";
    }
}

function extractDomain(url) {
    var domain;
    //find & remove protocol (http, ftp, etc.) and get domain
    if (url.indexOf("://") > -1) {
        domain = url.split('/')[2];
    }
    else {
        domain = url.split('/')[0];
    }

    //find & remove port number
    domain = domain.split(':')[0];

    return domain;
}

function w3poGetParameterByName(name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.href);
    if (results == null)
        return "";
    else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
}

var w3productOptionsJS = function ($) {
    //sort elements
    $.fn.sortElements = function () { var t = [].sort; return function (n, e) { e = e || function () { return this }; var r = this.map(function () { var t = e.call(this), n = t.parentNode, r = n.insertBefore(document.createTextNode(""), t.nextSibling); return function () { if (n === this) throw new Error("You can't sort elements if any one is a descendant of another."); n.insertBefore(this, r), n.removeChild(r) } }); return t.call(this, n).each(function (t) { r[t].call(e.call(this)) }) } }();

    //startsWith polyfil
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        };
    }

    //polyfill for promise.all


    if (!$.magnificPopup) {
        /*! Magnific Popup - v1.1.0 - 2016-02-20
        * http://dimsemenov.com/plugins/magnific-popup/
        * Copyright (c) 2016 Dmitry Semenov; */
        !function (a) { "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : $) }(function (a) { var b, c, d, e, f, g, h = "Close", i = "BeforeClose", j = "AfterClose", k = "BeforeAppend", l = "MarkupParse", m = "Open", n = "Change", o = "mfp", p = "." + o, q = "mfp-ready", r = "mfp-removing", s = "mfp-prevent-close", t = function () { }, u = !!$, v = a(window), w = function (a, c) { b.ev.on(o + a + p, c) }, x = function (b, c, d, e) { var f = document.createElement("div"); return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f }, y = function (c, d) { b.ev.triggerHandler(o + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d])) }, z = function (c) { return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn }, A = function () { a.magnificPopup.instance || (b = new t, b.init(), a.magnificPopup.instance = b) }, B = function () { var a = document.createElement("p").style, b = ["ms", "O", "Moz", "Webkit"]; if (void 0 !== a.transition) return !0; for (; b.length;) if (b.pop() + "Transition" in a) return !0; return !1 }; t.prototype = { constructor: t, init: function () { var c = navigator.appVersion; b.isLowIE = b.isIE8 = document.all && !document.addEventListener, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {} }, open: function (c) { var e; if (c.isObj === !1) { b.items = c.items.toArray(), b.index = 0; var g, h = c.items; for (e = 0; e < h.length; e++) if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) { b.index = e; break } } else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0; if (b.isOpen) return void b.updateItemHTML(); b.types = [], f = "", c.mainEl && c.mainEl.length ? b.ev = c.mainEl.eq(0) : b.ev = d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function () { b.close() }), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function (a) { b._checkIfClose(a.target) && b.close() }), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading)); var i = a.magnificPopup.modules; for (e = 0; e < i.length; e++) { var j = i[e]; j = j.charAt(0).toUpperCase() + j.slice(1), b["init" + j].call(b) } y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function (a, b, c, d) { c.close_replaceWith = z(d.type) }), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({ overflow: b.st.overflowY, overflowX: "hidden", overflowY: b.st.overflowY }) : b.wrap.css({ top: v.scrollTop(), position: "absolute" }), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({ height: d.height(), position: "absolute" }), b.st.enableEscapeKey && d.on("keyup" + p, function (a) { 27 === a.keyCode && b.close() }), v.on("resize" + p, function () { b.updateSize() }), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f); var k = b.wH = v.height(), n = {}; if (b.fixedContentPos && b._hasScrollBar(k)) { var o = b._getScrollbarSize(); o && (n.marginRight = o) } b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden"); var r = b.st.mainClass; return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), y("BuildControls"), a("html").css(n), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function () { b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn) }, 16), b.isOpen = !0, b.updateSize(k), y(m), c }, close: function () { b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function () { b._close() }, b.st.removalDelay)) : b._close()) }, _close: function () { y(h); var c = r + " " + q + " "; if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) { var e = { marginRight: "" }; b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e) } d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j) }, updateSize: function (a) { if (b.isIOS) { var c = document.documentElement.clientWidth / window.innerWidth, d = window.innerHeight * c; b.wrap.css("height", d), b.wH = d } else b.wH = a || v.height(); b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize") }, updateItemHTML: function () { var c = b.items[b.index]; b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index)); var d = c.type; if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) { var f = b.st[d] ? b.st[d].markup : !1; y("FirstMarkupParse", f), f ? b.currTemplate[d] = a(f) : b.currTemplate[d] = !0 } e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder"); var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]); b.appendContent(g, d), c.preloaded = !0, y(n, c), e = c.type, b.container.prepend(b.contentContainer), y("AfterChange") }, appendContent: function (a, c) { b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "", y(k), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content) }, parseEl: function (c) { var d, e = b.items[c]; if (e.tagName ? e = { el: a(e) } : (d = e.type, e = { data: e, src: e.src }), e.el) { for (var f = b.types, g = 0; g < f.length; g++) if (e.el.hasClass("mfp-" + f[g])) { d = f[g]; break } e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href")) } return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, y("ElementParse", e), b.items[c] }, addGroup: function (a, c) { var d = function (d) { d.mfpEl = this, b._openClick(d, a, c) }; c || (c = {}); var e = "click.magnificPopup"; c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d))) }, _openClick: function (c, d, e) { var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick; if (f || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) { var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn; if (g) if (a.isFunction(g)) { if (!g.call(b)) return !0 } else if (v.width() < g) return !0; c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e) } }, updateStatus: function (a, d) { if (b.preloader) { c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading); var e = { status: a, text: d }; y("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function (a) { a.stopImmediatePropagation() }), b.container.addClass("mfp-s-" + a), c = a } }, _checkIfClose: function (c) { if (!a(c).hasClass(s)) { var d = b.st.closeOnContentClick, e = b.st.closeOnBgClick; if (d && e) return !0; if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0; if (c === b.content[0] || a.contains(b.content[0], c)) { if (d) return !0 } else if (e && a.contains(document, c)) return !0; return !1 } }, _addClassToMFP: function (a) { b.bgOverlay.addClass(a), b.wrap.addClass(a) }, _removeClassFromMFP: function (a) { this.bgOverlay.removeClass(a), b.wrap.removeClass(a) }, _hasScrollBar: function (a) { return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height()) }, _setFocus: function () { (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus() }, _onFocusIn: function (c) { return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1) }, _parseMarkup: function (b, c, d) { var e; d.data && (c = a.extend(d.data, c)), y(l, [b, c, d]), a.each(c, function (c, d) { if (void 0 === d || d === !1) return !0; if (e = c.split("_"), e.length > 1) { var f = b.find(p + "-" + e[0]); if (f.length > 0) { var g = e[1]; "replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class"))) : f.attr(e[1], d) } } else b.find(p + "-" + c).html(d) }) }, _getScrollbarSize: function () { if (void 0 === b.scrollbarSize) { var a = document.createElement("div"); a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a) } return b.scrollbarSize } }, a.magnificPopup = { instance: null, proto: t.prototype, modules: [], open: function (b, c) { return A(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b) }, close: function () { return a.magnificPopup.instance && a.magnificPopup.instance.close() }, registerModule: function (b, c) { c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b) }, defaults: { disableOn: 0, key: null, midClick: !1, mainClass: "", preloader: !0, focus: "", closeOnContentClick: !1, closeOnBgClick: !0, closeBtnInside: !0, showCloseBtn: !0, enableEscapeKey: !0, modal: !1, alignTop: !1, removalDelay: 0, prependTo: null, fixedContentPos: "auto", fixedBgPos: "auto", overflowY: "auto", closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>', tClose: "Close (Esc)", tLoading: "Loading...", autoFocusLast: !0 } }, a.fn.magnificPopup = function (c) { A(); var d = a(this); if ("string" == typeof c) if ("open" === c) { var e, f = u ? d.data("magnificPopup") : d[0].magnificPopup, g = parseInt(arguments[1], 10) || 0; f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({ mfpEl: e }, d, f) } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1)); else c = a.extend(!0, {}, c), u ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c); return d }; var C, D, E, F = "inline", G = function () { E && (D.after(E.addClass(C)).detach(), E = null) }; a.magnificPopup.registerModule(F, { options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" }, proto: { initInline: function () { b.types.push(F), w(h + "." + F, function () { G() }) }, getInline: function (c, d) { if (G(), c.src) { var e = b.st.inline, f = a(c.src); if (f.length) { var g = f[0].parentNode; g && g.tagName && (D || (C = e.hiddenClass, D = x(C), C = "mfp-" + C), E = f.after(D).detach().removeClass(C)), b.updateStatus("ready") } else b.updateStatus("error", e.tNotFound), f = a("<div>"); return c.inlineElement = f, f } return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d } } }); var H, I = "ajax", J = function () { H && a(document.body).removeClass(H) }, K = function () { J(), b.req && b.req.abort() }; a.magnificPopup.registerModule(I, { options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' }, proto: { initAjax: function () { b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K) }, getAjax: function (c) { H && a(document.body).addClass(H), b.updateStatus("loading"); var d = a.extend({ url: c.src, success: function (d, e, f) { var g = { data: d, xhr: f }; y("ParseAjax", g), b.appendContent(a(g.data), I), c.finished = !0, J(), b._setFocus(), setTimeout(function () { b.wrap.addClass(q) }, 16), b.updateStatus("ready"), y("AjaxContentAdded") }, error: function () { J(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src)) } }, b.st.ajax.settings); return b.req = a.ajax(d), "" } } }); var L, M = function (c) { if (c.data && void 0 !== c.data.title) return c.data.title; var d = b.st.image.titleSrc; if (d) { if (a.isFunction(d)) return d.call(b, c); if (c.el) return c.el.attr(d) || "" } return "" }; a.magnificPopup.registerModule("image", { options: { markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>', cursor: "mfp-zoom-out-cur", titleSrc: "title", verticalFit: !0, tError: '<a href="%url%">The image</a> could not be loaded.' }, proto: { initImage: function () { var c = b.st.image, d = ".image"; b.types.push("image"), w(m + d, function () { "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor) }), w(h + d, function () { c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p) }), w("Resize" + d, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage) }, resizeImage: function () { var a = b.currItem; if (a && a.img && b.st.image.verticalFit) { var c = 0; b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c) } }, _onImageHasSize: function (a) { a.img && (a.hasSize = !0, L && clearInterval(L), a.isCheckingImgSize = !1, y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1)) }, findImageSize: function (a) { var c = 0, d = a.img[0], e = function (f) { L && clearInterval(L), L = setInterval(function () { return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500))) }, f) }; e(1) }, getImage: function (c, d) { var e = 0, f = function () { c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, y("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g())) }, g = function () { c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0) }, h = b.st.image, i = d.find(".mfp-img"); if (i.length) { var j = document.createElement("img"); j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1) } return b._parseMarkup(d, { title: M(c), img_replaceWith: c.img }, c), b.resizeImage(), c.hasSize ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d) } } }); var N, O = function () { return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N }; a.magnificPopup.registerModule("zoom", { options: { enabled: !1, easing: "ease-in-out", duration: 300, opener: function (a) { return a.is("img") ? a : a.find("img") } }, proto: { initZoom: function () { var a, c = b.st.zoom, d = ".zoom"; if (c.enabled && b.supportsTransition) { var e, f, g = c.duration, j = function (a) { var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"), d = "all " + c.duration / 1e3 + "s " + c.easing, e = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" }, f = "transition"; return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b }, k = function () { b.content.css("visibility", "visible") }; w("BuildControls" + d, function () { if (b._allowZoom()) { if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k(); f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function () { f.css(b._getOffset(!0)), e = setTimeout(function () { k(), setTimeout(function () { f.remove(), a = f = null, y("ZoomAnimationEnded") }, 16) }, g) }, 16) } }), w(i + d, function () { if (b._allowZoom()) { if (clearTimeout(e), b.st.removalDelay = g, !a) { if (a = b._getItemToZoom(), !a) return; f = j(a) } f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function () { f.css(b._getOffset()) }, 16) } }), w(h + d, function () { b._allowZoom() && (k(), f && f.remove(), a = null) }) } }, _allowZoom: function () { return "image" === b.currItem.type }, _getItemToZoom: function () { return b.currItem.hasSize ? b.currItem.img : !1 }, _getOffset: function (c) { var d; d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem); var e = d.offset(), f = parseInt(d.css("padding-top"), 10), g = parseInt(d.css("padding-bottom"), 10); e.top -= a(window).scrollTop() - f; var h = { width: d.width(), height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f }; return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h } } }); var P = "iframe", Q = "//about:blank", R = function (a) { if (b.currTemplate[P]) { var c = b.currTemplate[P].find("iframe"); c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none")) } }; a.magnificPopup.registerModule(P, { options: { markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>', srcAction: "iframe_src", patterns: { youtube: { index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" }, vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" }, gmaps: { index: "//maps.google.", src: "%id%&output=embed" } } }, proto: { initIframe: function () { b.types.push(P), w("BeforeChange", function (a, b, c) { b !== c && (b === P ? R() : c === P && R(!0)) }), w(h + "." + P, function () { R() }) }, getIframe: function (c, d) { var e = c.src, f = b.st.iframe; a.each(f.patterns, function () { return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0 }); var g = {}; return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d } } }); var S = function (a) { var c = b.items.length; return a > c - 1 ? a - c : 0 > a ? c + a : a }, T = function (a, b, c) { return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c) }; a.magnificPopup.registerModule("gallery", { options: { enabled: !1, arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', preload: [0, 2], navigateByImgClick: !0, arrows: !0, tPrev: "Previous (Left arrow key)", tNext: "Next (Right arrow key)", tCounter: "%curr% of %total%" }, proto: { initGallery: function () { var c = b.st.gallery, e = ".mfp-gallery"; return b.direction = !0, c && c.enabled ? (f += " mfp-gallery", w(m + e, function () { c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function () { return b.items.length > 1 ? (b.next(), !1) : void 0 }), d.on("keydown" + e, function (a) { 37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next() }) }), w("UpdateStatus" + e, function (a, c) { c.text && (c.text = T(c.text, b.currItem.index, b.items.length)) }), w(l + e, function (a, d, e, f) { var g = b.items.length; e.counter = g > 1 ? T(c.tCounter, f.index, g) : "" }), w("BuildControls" + e, function () { if (b.items.length > 1 && c.arrows && !b.arrowLeft) { var d = c.arrowMarkup, e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s), f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s); e.click(function () { b.prev() }), f.click(function () { b.next() }), b.container.append(e.add(f)) } }), w(n + e, function () { b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function () { b.preloadNearbyImages(), b._preloadTimeout = null }, 16) }), void w(h + e, function () { d.off(e), b.wrap.off("click" + e), b.arrowRight = b.arrowLeft = null })) : !1 }, next: function () { b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML() }, prev: function () { b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML() }, goTo: function (a) { b.direction = a >= b.index, b.index = a, b.updateItemHTML() }, preloadNearbyImages: function () { var a, c = b.st.gallery.preload, d = Math.min(c[0], b.items.length), e = Math.min(c[1], b.items.length); for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a); for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a) }, _preloadItem: function (c) { if (c = S(c), !b.items[c].preloaded) { var d = b.items[c]; d.parsed || (d = b.parseEl(c)), y("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function () { d.hasSize = !0 }).on("error.mfploader", function () { d.hasSize = !0, d.loadError = !0, y("LazyLoadError", d) }).attr("src", d.src)), d.preloaded = !0 } } } }); var U = "retina"; a.magnificPopup.registerModule(U, { options: { replaceSrc: function (a) { return a.src.replace(/\.\w+$/, function (a) { return "@2x" + a }) }, ratio: 1 }, proto: { initRetina: function () { if (window.devicePixelRatio > 1) { var a = b.st.retina, c = a.ratio; c = isNaN(c) ? c() : c, c > 1 && (w("ImageHasSize." + U, function (a, b) { b.img.css({ "max-width": b.img[0].naturalWidth / c, width: "100%" }) }), w("ElementParse." + U, function (b, d) { d.src = a.replaceSrc(d, c) })) } } } }), A() });

        //magnific will get bound to whichever jquery it's init'd on so this is to do that
        $(".hoihoiuhoibjkhbkhbihoh").magnificPopup({ type: 'image' });
    }

    $.poDebug = false;

    if (typeof (poDebug) != 'undefined') {
        $.poDebug = true;
    }

    var currentScriptUrl = getScriptUrlPO();
    var domainUrl = "https://" + extractDomain(currentScriptUrl);

    var manualSubmit = false;
    var customSubmit = false;
    var skipAddOns = false;
    var skipFixCartItems = false;
    var poLookupTags = false;

    window.poFixItemsQueue = window.poFixItemsQueue || Promise.resolve();
    window.poFixItemsRunning = window.poFixItemsRunning || false;

    let poLatestCart = null;
    let poFixItemsTimer = null;
    let poLastProcessedSig = null;

    // Create a light signature of cart state to skip identical reprocessing
    function poCartSig(cart) {
        try {
            return (cart.items || []).map(i =>
                `${i.id}:${i.quantity}:${(i.properties && (i.properties._options_group_id || ''))}`
            ).join('|');
        } catch {
            return String(Date.now());
        }
    }

    /**
     * Use this instead of calling fixItems directly.
     */
    window.scheduleFixItems = function (cart, isAsync = false, callback) {
        poLatestCart = cart;
        clearTimeout(poFixItemsTimer);

        poFixItemsTimer = setTimeout(() => {
            const nextSig = poCartSig(poLatestCart);
            if (nextSig === poLastProcessedSig) {
                if (callback) callback(poLatestCart);
                return; // no-op: identical cart processed already
            }

            window.poFixItemsQueue = window.poFixItemsQueue.then(() => {
                if (window.poFixItemsRunning) return; // belt-and-suspenders
                window.poFixItemsRunning = true;

                return new Promise((resolve) => {
                    // call original fixItems unchanged
                    fixItems(poLatestCart, isAsync, function (updatedCart) {
                        poLastProcessedSig = poCartSig(updatedCart || poLatestCart);
                        if (callback) callback(updatedCart || poLatestCart);
                        resolve();
                    });
                }).finally(() => {
                    window.poFixItemsRunning = false;
                });

            }).catch(console.error);
        }, 50); // tiny debounce collapses rapid triggers
    };


    if (typeof (window.poManualSubmit) != 'undefined') {
        if (window.poManualSubmit == true) {
            manualSubmit = true;
        }
    }

    if (typeof (window.poCustomSubmit) != 'undefined') {
        if (window.poCustomSubmit == true) {
            customSubmit = true;
        }
    }

    if (typeof (window.poSkipAddOns) != 'undefined') {
        if (window.poSkipAddOns == true) {
            skipAddOns = true;
        }
    }

    if (typeof (window.skipFixCartItems) != 'undefined') {
        if (window.skipFixCartItems == true) {
            skipFixCartItems = true;
        }
    }

    if (typeof (window.poLookupTags) != 'undefined') {
        if (window.poLookupTags == true) {
            poLookupTags = true;
        }
    }


    if (!Array.isArray) {
        Array.isArray = function (arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }

    if ($(".w3-product-options").length) {
        /* fix for IOS bfcache issue */
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        }
    }

    var _options_group_id = optionsGenerateGuid();
    window.productsBeingAdded = false;

    (function ($) {
        $.fn.tipr = function (options) {
            var set = $.extend({ 'speed': 200, 'mode': 'bottom' }, options); return this.each(function () {
                var tipr_cont = '.tipr_container_' + set.mode; $(this).hover(function () {
                    var d_m = set.mode; if ($(this).attr('data-mode')) {
                        d_m = $(this).attr('data-mode')
                        tipr_cont = '.tipr_container_' + d_m;
                    }
                    var out = '<div class="tipr_container_' + d_m + '"><div class="tipr_point_' + d_m + '"><div class="tipr_content">' + $(this).attr('data-tip') + '</div></div></div>'; $(this).append(out); var w_t = $(tipr_cont).outerWidth(); var w_e = $(this).width(); var m_l = (w_e / 2) - (w_t / 2); $(tipr_cont).css('margin-left', m_l + 'px'); $(this).removeAttr('title alt'); $(tipr_cont).fadeIn(set.speed);
                }, function () { $(tipr_cont).remove(); });
            });
        };
    })($);

    var cartForm = $("form[action='/cart']");


    $(document).ajaxSuccess(function (event, xhr, settings) {
        if (settings) {
            if (settings.url == "/cart.js" || settings.url == "/cart.json" || settings.url == "change.js") {
                if (window.productsBeingAdded == false) {
                    if (!skipFixCartItems) {
                        scheduleFixItems($.parseJSON(xhr.responseText), false);
                    }
                    
                }
            }
        }
    });

    window.fixJSCartInputs = function (selector) {
        var hiddenItems = $("body").find(".options-group.options-hidden:not(.options-unlink)");

        $.each(hiddenItems, function () {
            var row = $(this);

            var inputBox1 = row.find(selector);

            var classes = row.attr("class").replace(/(\r\n|\n|\r)/gm, "").split(" ");

            $.each(classes, function (i, value) {
                if (value.indexOf("group-id-") != -1) {
                    var groupId = value;

                    var parentRow = $("body").find(".options-group." + groupId + ":not(.options-hidden)");

                    var inputBox2 = parentRow.find(selector);

                    inputBox1.attr("value", inputBox2.val());
                    inputBox1.val(inputBox2.val());

                }
            })
        });

    }

    window.poIsW3HiddenProduct = function (item) {
        if (item.properties["_options_hidden"] == "true") {
            return true;
        } else {
            return false;
        }
    }

    window.w3poReAddCartItemClasses = function (item, element) {
        if (item.properties["_options_hidden"]) {
            element.addClass("options-hidden")
        }

        if (item.properties["_options_group_id"]) {
            element.addClass("group-id-" + item.properties["_options_group_id"]);
            element.addClass("options-group");
        }
    }

    window.poFixCartObj = function (cart, callback) {
        
        scheduleFixItems(cart, true, callback);
       
        //clone by parsing to JSON and back
        var originalCart = JSON.parse(JSON.stringify(cart));

        var cart_count = 0;

        $.each(cart.items, function (i, item) {
            if (!window.poIsW3HiddenProduct(item)) {
                cart_count += item.quantity;
            }
        });

        cart.item_count = cart_count;

    }


    //try to fix extra charge product quantities in JS
    $(".options-group input[name^='updates[']").on("change", function () {
        window.fixJSCartInputs("input[name^='updates[']");
    });

    window.fixPOCart = function (isAsync = false) {
        $.ajax({
            method: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (data) {
                scheduleFixItems(data, isAsync);
            }
        });
    }

    window.fixPOCartPromise = function (isAsync = false) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: "/cart.js",
                dataType: "json",
                success: function (cartData) {
                    scheduleFixItems(cartData, isAsync, function (updatedCart) {
                        resolve(updatedCart);
                    });
                },
                error: function (err) {
                    reject(err);
                }
            });
        });
    };

 
    //load actual app
    $.ajax({
        method: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (data) {
            if (!skipFixCartItems) {
                scheduleFixItems(data, false);
            }

            $.each($(".w3-product-options"), function productOptionsEach() {
                var productOptionsContainer = $(this);

                var formTag = productOptionsContainer.closest("form");
                formTag.addClass("w3-product-options-form");

                var fields = [];
                var productsToAdd = [];

                if (productOptionsContainer.hasClass("loaded")) {
                    return;
                } else {
                    productOptionsContainer.addClass("loaded")
                }

                formTag.attr("enctype", "multipart/form-data");

                var addToCartBtn = formTag.find("input[type='submit'],button[type='submit']").first();

                addToCartBtn.addClass("w3-options-add-to-cart");


                window.shopifyAnalyticsHandler = null;

                try {
                    if ($._data && $(formTag).get(0)) {
                        if ($._data($(formTag).get(0), "events")) {
                            if ($._data($(formTag).get(0), "events").submit) {
                                $.each($._data($(formTag).get(0), "events").submit, function (i, submitter) {
                                    if (submitter.handler) {
                                        if (submitter.handler.toString().indexOf("ShopifyAnalytics") != -1) {
                                            window.shopifyAnalyticsHandler = submitter.handler;
                                        }
                                    }
                                });
                            }
                        }
                    }

                } catch (e) {
                    //console.log(e);
                }



                try {
                    if (!manualSubmit) {

                        $(".w3-options-add-to-cart").unbind("click");


                        formTag.unbind("click");

                        jQuery(".w3-options-add-to-cart").unbind();

                        jQuery(".w3-product-options-form").unbind("submit");

                        jQuery(".w3-options-add-to-cart").bind("click", function (e) {
                            e.stopPropagation();
                        });

                    }

                } catch (e) {
                    //console.log(e);
                }

                //remove click handlers
                //addToCartBtn.unbind("click");
                //console.log(addToCartBtn.getPath());


                var cssId = 'product-options-css';  // you could encode the css path itself to generate id..
                if (!document.getElementById(cssId)) {
                    var head = document.getElementsByTagName('head')[0];
                    var link = document.createElement('link');
                    link.id = cssId;
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = domainUrl + '/css/options.css?shopName=' + Shopify.shop + "&c=" + Math.random();
                    link.media = 'all';
                    head.appendChild(link);
                }

                var dataProductID = productOptionsContainer.data("product-id");
                var dataProductTags = productOptionsContainer.data("tags");

                if (poLookupTags == true) {
                    dataProductTags = "poLookupTags";
                }

                if (typeof (dataProductID) != 'undefined') {

                    var productUrl = location.protocol + '//' + location.host + location.pathname + ".json";

                    $.ajax({
                        method: "GET",
                        url: productUrl,
                        dataType: "jsonp",
                        success: function (data) {
                            var product = data.product;

                            loadOptionsAjax(formTag, productOptionsContainer, fields, productsToAdd, dataProductID, encodeURIComponent(dataProductTags), product);

                        },
                        error: function (xhr, text, error) {
                            console.log(error);
                        }
                    });



                } else {
                    var dataHandle = productOptionsContainer.data("handle");
                    var productUrl;

                    if (typeof (dataHandle) != 'undefined') {
                        productUrl = window.Shopify.routes.root + "products/" + dataHandle + ".json";

                    } else {
                        productUrl = location.protocol + '//' + location.host + location.pathname + ".json";
                    }

                   // console.log(productUrl);

                    $.ajax({
                        method: "GET",
                        url: productUrl,
                        dataType: "jsonp",
                        success: function (data) {
                            var product = data.product;

                            //console.log(product);
                            var productTags = null;
                            if (poLookupTags == true) {
                                productTags = "poLookupTags";
                            } else {
                                productTags = product.tags;
                            }

                            loadOptionsAjax(formTag, productOptionsContainer, fields, productsToAdd, product.id, encodeURIComponent(productTags), product);
                        },
                        error: function (xhr, text, error) {
                            var err = text + ", " + error;
                            console.log("Request Failed: " + err);
                            
                        }
                    });
                }


            });
        }
    });

    function loadOptionsAjax(formTag, productOptionsContainer, fields, productsToAdd, productId, productTags, mainProduct) {
        var options = w3poGetParameterByName("options");

        if (typeof (options) == "undefined") {
            options = "";
        }



        $.ajax({
            method: "GET",
            url: domainUrl + "/api/productwidget?shopName=" + Shopify.shop + "&productId=" + productId + "&tags=" + productTags + "&options=" + options,
            dataType: "jsonp",
            success: function (data) {

                try {
                    if (data.formSelectionJson) {
                        window.poPreviousformSelection = JSON.parse(data.formSelectionJson);
                        productOptionsContainer.closest("form").append("<input name='properties[_saved_selection_guid]' type='hidden' value='" + options + "' />");
                    }
                } catch (ex) { }



                fields = data.fields;
                var language = data.language;
                var settings = {
                    moneyFormat: data.money_format,
                    defaultCurrency: data.default_currency,
                    language: language,
                    shop: Shopify.shop,
                    disableCartEdit: data.disableCartEdit
                };

                var head = document.head || document.getElementsByTagName('head')[0],
                    fieldStyles = document.createElement('style');
                head.appendChild(fieldStyles);
                fieldStyles.type = 'text/css';
                fieldStyles.setAttribute('id', 'product-options-custom-fieldstyles');

                var savedOptionsLink = null;

                window.w3generatePreloadLink = function (x) {
                    var returnAlert = true;

                    if (x === undefined) {
                        returnAlert = true;
                    } else {
                        returnAlert = x;
                    }

                    savedOptionsLink = null;

                    var urlFields = [];

                    $.each(fields, function (i) {
                       
                        var field = fields[i];
                        var fieldDiv = productOptionsContainer.find("[data-field-id='" + field.id + "']");

                        if (fieldDiv.is(":empty")) {
                            return true;//skip loop iteration
                        }

                        if (field.type == "textbox") {

                            //find input to get value
                            var input = fieldDiv.find("input");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });

                        } else if (field.type == "textarea") {
                            //find input to get value
                            var input = fieldDiv.find("textarea");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });

                        } else if (field.type == "number") {
                            //find input to get value
                            var input = fieldDiv.find("input");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });
                        } else if (field.type == "date") {
                            //find input to get value
                            var input = fieldDiv.find("input");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });
                        }else if (field.type == "dropdown") {

                            var input = fieldDiv.find("select.product-options-dropdown");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });

                        } else if (field.type == "checkbox") {
                            var input = fieldDiv.find("input[type='hidden']");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });
                        } else if (field.type == "radiobutton") {

                            var input = fieldDiv.find("input[type='radio']:checked");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });
                        } else if (field.type == "colorpicker") {
                            var input = fieldDiv.find("input[type='hidden']");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });
                        } else if (field.type == "imagepicker") {
                            var input = fieldDiv.find("input[type='hidden']");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });
                        } else if (field.type == "textpicker") {
                            var input = fieldDiv.find("input[type='hidden']");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });
                        } else if (field.type == "length") {
                            var input = fieldDiv.find("select.length-val");

                            urlFields.push({
                                id: field.name,
                                values: [input.val()]
                            });

                        } else if (field.type == "area") {
                            var wInput = fieldDiv.find("select.width-val");
                            var hInput = fieldDiv.find("select.height-val");

                            var arr = [];
                            arr.push(wInput.val());
                            arr.push(hInput.val());

                            urlFields.push({
                                id: field.name,
                                values: arr
                            });
                        }


                    });

                    var savedUrl = null;
                    if (urlFields.length > 0) {
                        var jsonString = JSON.stringify(urlFields);

                        $.ajax({
                            method: "POST",
                            url: domainUrl + "/api/formselection?shop=" + Shopify.shop + "&adminCreated=" + returnAlert,
                            data: jsonString,
                            contentType: 'application/json',
                            success: function (data) {
                                var variant = w3poGetParameterByName("variant");
                                if (typeof (variant) != "undefined" && variant != "") {
                                    savedUrl = window.location.href.split('?')[0] + "?variant=" + variant + "&options=" + data;
                                } else {
                                    savedUrl = window.location.href.split('?')[0] + "?options=" + data;
                                }
                            },
                            async: false
                        });

                        if (returnAlert == true) {
                            navigator.clipboard.writeText(savedUrl).then(function () {
                                alert("Copied to clipboard!");
                            });
                        } else {
                            return savedUrl;
                        }
                    } else {
                        return savedUrl;
                    }


                }



                var doValidation = true;

                formTag.change(function (evt) {
                    var formDataJson = $(formTag).serializeArray();

                    //send new form values to image customizer
                    applyFormChangeToImageCustomizer($, formDataJson)

                    var target = $(evt.target);

                    if ($.poDebug) {
                        console.log("formTag.change()");
                        console.log("target:");
                        console.log(target);
                    }

                    if (target.hasClass("product-options-control")) {
                        var id = target.closest(".product-options-control-container").data("field-id");

                        var field = getField(id, fields)

                        if (target.hasClass("has-values") || target.hasClass("product-options-date")) {
                            var value;

                            if (target.hasClass("product-options-checkbox")) {
                                var items = [];

                                target.closest(".product-options-control-container").find(".product-options-checkbox:checked").each(function () { items.push($(this).val()); });

                                value = items;

                                target.closest(".product-options-control-container").find("input[type=hidden]").val(items.join(", "));
                            } else {
                                value = target.val();
                            }

                            formChange(field, value, productOptionsContainer, fields, productsToAdd, settings, target.closest(".product-options-control-container"));
                        }

                        //handle multi file uploader
                        if (field.type == 'fileupload') {

                            if (field.settings.allowMultipleUploads == true) {
                                var max = field.settings.maxUploads;
                                var div = productOptionsContainer.find("[data-field-id='" + field.id + "']");

                                var currentUploads = parseInt(div.find(".product-options-fileupload").length);
                                var hasEmptyFileUpload = false;

                                $.each(div.find("input"), function () {
                                    if ($(this).val() == '') {
                                        hasEmptyFileUpload = true;

                                        return false;
                                    }
                                });


                                if ((currentUploads < max) && hasEmptyFileUpload == false) {
                                    var multiUploadContainer = div.find(".product-options-multi-fileupload");

                                    var newUpload = $(field.html).find("input");
                                    newUpload.attr("name", "properties[" + field.name + (currentUploads + 1) + "]")

                                    multiUploadContainer.append(newUpload);
                                }
                            }
                        }

                    }

                });

                //listen on quantity changes
                if (formTag.has("input[name='quantitiy']")) {
                    formTag.find("input[name='quantity']").change(function () {
                        productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                    });
                }

                function doSubmit(e) {
                
                    if (settings.disableCartEdit == false) {
                        savedOptionsLink = window.w3generatePreloadLink(false);
                    }
                    
                    var outofstock = false;

                    $(".w3-product-options .product-options-errors").remove();
                    formTag.removeClass("product-options-has-errors");

                    // prevent submit
                    if (e) {
                      e.preventDefault();
                    }
                    

                    //fix area field input
                    $.each(productOptionsContainer.find(".product-options-area-container"), function () {
                        var div = $(this);

                        var widthSel = div.find("select.width-val");
                        var heightSel = div.find("select.height-val");

                        var widthInput = div.find("input.width-val");
                        var heightInput = div.find("input.height-val");

                        widthInput.val("");
                        heightInput.val("");

                        var fracWidthSel = widthSel.next("select");
                        var fracHeightSel = heightSel.next("select");

                        var wVal = widthSel.val();
                        var hVal = heightSel.val();

                        if (fracWidthSel.length > 0 && fracWidthSel.val() && wVal) {
                            wVal = wVal + " " + fracWidthSel.val();
                        }

                        if (fracHeightSel.length > 0 && fracHeightSel.val() && hVal) {
                            hVal = hVal + " " + fracHeightSel.val();
                        }



                        if (wVal && hVal) { //only fill in if both are available.
                            widthInput.val(wVal);
                            heightInput.val(hVal);
                        }

                    });

                    //fix length field
                    $.each(productOptionsContainer.find(".product-options-length-container"), function () {
                        var div = $(this);

                        var lengthSel = div.find("select.length-val");

                        var lengthInput = div.find("input.length-val");

                        lengthInput.val("");

                        var fracWidthSel = lengthSel.next("select");

                        var wVal = lengthSel.val();

                        if (fracWidthSel.length > 0 && fracWidthSel.val() && wVal) {
                            wVal = wVal + " " + fracWidthSel.val();
                        }



                        if (wVal) {
                            lengthInput.val(wVal);
                        }

                    });

                    //check for errors
                    var errors = checkForRequiredFields(productOptionsContainer, fields, language);

                    if (errors.length > 0) {

                        formTag.addClass("product-options-has-errors");

                        productOptionsContainer.append("<div class='product-options-errors'>" + errors.join("") + "</div>");

                        var offsetTop = 20;

                        if (formTag.data("product-options-scroll")) {
                            offsetTop = formTag.data("product-options-scroll");
                        }

                        var extra = ($(window).height() * 0.5) - ($(".product-options-errors").height() / 2);

                        $('html,body').animate({
                            scrollTop: $(".product-options-errors").offset().top - offsetTop - extra
                        }, 300, function () {
                            $(".product-options-errors").fadeOut(125, function () {
                                $(".product-options-errors").fadeIn(125, function () {
                                    $(".product-options-errors").fadeOut(125, function () {
                                        $(".product-options-errors").fadeIn(125);
                                    });
                                });
                            });
                        });

                        if (e) {
                            e.stopPropagation();
                        }

                        return false;
                    } else {
                     

                        $(".w3-product-options").addClass("is-submit");
                        formTag.addClass("w3-is-submit");


                        formTag.find("[type='submit']").attr("disabled", "");
                        formTag.find("[type='submit']").css("cursor", "wait");

                        //try to remove disbled ID field (missing paramater error)
                        formTag.find("input:hidden[name='id']").removeAttr("disabled");

                        if (settings.disableCartEdit == false) {
                            if (savedOptionsLink != null) {
                                var hiddenSavedInput = $("<input type='hidden' name='properties[_options_edit_url]' value='" + savedOptionsLink + "' />");
                                formTag.append(hiddenSavedInput);
                            }
                        }
                        


                        if (productsToAdd.length > 0) {
                            var productsToAddCopy = productsToAdd.slice();

                            var hiddenInput = $("<input type='hidden' name='properties[_options_group_id]' value='" + _options_group_id + "' />");
                            formTag.append(hiddenInput);

                            var addOnProductsList = [];
                            productsToAddCopy.forEach((p) => {
                                var obj = {
                                    id: p.id,
                                    variantId: p.variantId,
                                    handle: p.handle,
                                    actionID: p.action
                                }
                                addOnProductsList.push(obj);
                            });

                            var addonProducts = $("<input type='hidden' name='properties[_options_addon_products]' value='" + JSON.stringify(addOnProductsList) + "' />");
                            formTag.append(addonProducts);



                            var retryCount = 4;

                            function addItems() {
                                
                                window.productsBeingAdded = true;

                                if (productsToAdd.length >= 1) {

                                    if (skipAddOns == false) {
                                        var item = productsToAdd.pop();

                                        var quantity = 1;

                                        //main item qty
                                        var mainQty = formTag.find("input[name='quantity']");

                                        if (mainQty.length > 0 && $.isNumeric(mainQty.val())) {
                                            quantity = parseInt(mainQty.val());
                                        }


                                        var product = {
                                            quantity: 1,
                                            id: item.variantId,
                                            properties: {
                                                "_options_group_id": _options_group_id,
                                                "_options_hidden": 'true',
                                                "_options_action": item.action
                                            }
                                        }
                                        if (formTag.find("input[name='_options_unlink']").length > 0) {
                                            product.properties["_options_unlink"] = "1";
                                        }

                                        if (item.area) { //used for both area and length
                                            product.quantity = product.quantity * item.qtyMultiplier * item.area;
                                            product.properties["_options_qty_mult"] = item.qtyMultiplier;
                                            product.properties["_options_area"] = item.area;
                                        }


                                        var url = "/cart/add.js";

                                        $.ajax({
                                            type: "POST",
                                            url: url,
                                            data: product,
                                            dataType: "json",
                                            success: function (data) {

                                                document.querySelector('body').dispatchEvent(new CustomEvent('productOptionsAddToCartJS', { bubbles: true, cancelable: true, detail: [product] }));
                                                addItems();
                                            },
                                            error: function (data) {
                                                if (retryCount > 0) {
                                                    productsToAdd.push(item);

                                                    //console.log("Error when trying to add product.. retrying.. " + retryCount);

                                                    retryCount--;
                                                } else {

                                                    if (data.status == 422 && formTag.hasClass("w3-error-on-outofstock")) {

                                                        alert(JSON.parse(data.responseText).description);

                                                        setTimeout(function () {
                                                            $(".w3-product-options").removeClass("is-submit");
                                                            formTag.find("[type='submit']").removeAttr("disabled");
                                                            formTag.find("[type='submit']").css("cursor", "pointer");
                                                        }, 50);

                                                        outofstock = true;

                                                        productsToAdd = productsToAddCopy;
                                                    } else {
                                                        //add to error log
                                                        var app = domainUrl.replace("https://", "");

                                                        $.ajax({
                                                            type: "POST",
                                                            url: domainUrl + "/api/apperror",
                                                            data: { app: app, shopName: Shopify.shop, error: data.responseText }
                                                        });


                                                    }

                                                }

                                                if (!outofstock)
                                                    addItems();
                                            }
                                        });

                                    } else {
                                        //skipping addons. submit form
                                        if (customSubmit == false) {
                                            setTimeout(function () { formTag[0].submit(); }, 50);
                                        } else {
                                            if (typeof productOptionsSubmitCallback != "undefined") {
                                                if (productOptionsSubmitCallback.length) {
                                                    let data = new FormData(formTag[0]);
                                                    productOptionsSubmitCallback(data);
                                                }
                                            }
                                        }

                                    }

                                    

                                } else {

                                    if (typeof (fbq) != 'undefined') {
                                        var mainQty = formTag.find("input[name='quantity']");

                                        if (!$.isNumeric(mainQty.val())) {
                                            mainQty = 1;
                                        } else {
                                            mainQty = 1;//i dunno
                                        }

                                        var variantID = formTag.find("[name='id']").val();

                                        var variantPrice = 0;

                                        $.each(mainProduct.variants, function (i, variant2) {
                                            if (variant2.id == variantID) {
                                                variantPrice = variant2.price;
                                            }
                                        });


                                        if (settings.shop != 'architects-fairies.myshopify.com') {
                                            fbq('track', 'AddToCart', {
                                                value: variantPrice,
                                                content_name: mainProduct.title,
                                                num_items: mainQty,
                                                currency: settings.defaultCurrency,
                                                content_ids: '[' + productId + ']',
                                                content_type: 'product_group',
                                                content_category: mainProduct.product_type
                                            });
                                        }

                                    }

                                    if (outofstock == true) {
                                        return;
                                    }

                                    if (customSubmit == false) {
                                        setTimeout(function () { formTag[0].submit(); }, 50);
                                    } else {
                                        if (typeof productOptionsSubmitCallback != "undefined") {
                                            if (productOptionsSubmitCallback.length) {
                                                let data = new FormData(formTag[0]);
                                                productOptionsSubmitCallback(data);
                                            }
                                        }
                                    }
                                    
                                }
                            }

                            if (!outofstock)
                                addItems();


                        } else {
                            if (typeof (fbq) != 'undefined') {
                                var mainQty = formTag.find("input[name='quantity']");

                                if (!$.isNumeric(mainQty.val())) {
                                    mainQty = 1;
                                } else {
                                    mainQty = 1;//i dunno
                                }

                                var variantID = formTag.find("[name='id']").val();

                                var variantPrice = 0;

                                $.each(mainProduct.variants, function (i, variant2) {
                                    if (variant2.id == variantID) {
                                        variantPrice = variant2.price;
                                    }
                                });

                                if (settings.shop != 'architects-fairies.myshopify.com') {
                                    fbq('track', 'AddToCart', {
                                        value: variantPrice,
                                        content_name: mainProduct.title,
                                        num_items: mainQty,
                                        currency: settings.defaultCurrency,
                                        content_ids: '[' + productId + ']',
                                        content_type: 'product_group',
                                        content_category: mainProduct.product_type
                                    });
                                }

                            }

                            if (customSubmit == false) {
                                setTimeout(function () { formTag[0].submit(); }, 50);
                            } else {
                                if (typeof productOptionsSubmitCallback != "undefined") {
                                    if (productOptionsSubmitCallback.length) {
                                        let data = new FormData(formTag[0]);
                                        productOptionsSubmitCallback(data);
                                    }
                                }
                            }

                           
                        }
                    }
                }

                //bind to submit handler
                formTag.submit(doSubmit);

                window.poSubmitAddToCart = doSubmit;

                if (typeof (data.fields) != 'undefined') {
                    $.each(data.fields, function (index, field) {

                        field.shownByAction = null; //originally added fields.

                        //add custom field styles
                        if (field.type == 'textpicker') {
                            if (field.settings.borderColor && field.settings.borderColor != '') {
                                var css = ".product-options-textpicker-container[data-name='" + field.name + "'] span {border-color: " + field.settings.borderColor + "}";
                                fieldStyles.appendChild(document.createTextNode(css));
                            }

                            if (field.settings.borderColorSelected && field.settings.borderColorSelected != '') {
                                var css = ".product-options-textpicker-container[data-name='" + field.name + "'] span:hover, .product-options-textpicker-container[data-name='" + field.name + "'] span.textpicker-selected {box-shadow: inset 0px 0px 0px 2px " + field.settings.borderColorSelected + "; border-color: " + field.settings.borderColorSelected + ";}";
                                fieldStyles.appendChild(document.createTextNode(css));
                            }
                        }
                        if (field.type == 'imagepicker') {
                            if (field.settings.imageWidth && field.settings.imageWidth != '') {
                                var css = ".product-options-imagepicker-container[data-name='" + field.name + "'] .image-picker-item {max-width: " + field.settings.imageWidth + "px;}";
                                fieldStyles.appendChild(document.createTextNode(css));
                            }

                        }


                        var div = generateField(field, productOptionsContainer, fields, productsToAdd, settings);

                        if (field.settings.group && field.settings.group.length > 0) { //add accordion group
                            var accordionGroup = productOptionsContainer.children("[data-group-name='" + field.settings.group + "']");

                            if (!accordionGroup.length) {
                                accordionGroup = $("<div class='po-accordion-group open' style='display:none;' data-group-name='" + field.settings.group + "'></div>");

                                accordionGroup.append("<div class='po-accordion-title'>" + field.settings.group + "</div>");
                                productOptionsContainer.append(accordionGroup);

                                accordionGroup.find(".po-accordion-title").click(function () {
                                    $(this).closest(".po-accordion-group").toggleClass("open");
                                })
                            }

                            if (!field.hidden) {
                                accordionGroup.show();
                            }


                            accordionGroup.append(div);

                        } else {
                            productOptionsContainer.append(div);
                        }

                        field.elementDiv = div;

                        if (field.hidden == false) {
                            setPreloadSetters(field, div);

                            fieldAdded(field, div, productOptionsContainer, fields, productsToAdd, settings);
                        }
                    });




                }

                $('.options-tip').tipr({
                    'mode': 'top'
                });

                $('body').trigger("productOptionsLoaded", [productOptionsContainer]);
                document.querySelector('body').dispatchEvent(new CustomEvent('productOptionsLoadedJS', { bubbles: true, cancelable: true, detail: [productOptionsContainer] }));
            }
        });
    }

    function loadPreSelections(field, productOptionsContainer, fields, productsToAdd, settings, div) {

        try {
            //todo

            if (window.poPreviousformSelection) {
                var json = window.poPreviousformSelection;

                if (json) {

                    for (var i = 0; i < json.length; i++) {
                        var fieldItem = json[i];

                        if (fieldItem.id == field.name) {



                            if (field.setPreloadValue) {
                                field.setPreloadValue(fieldItem.values);
                            }

                            if (!fieldItem.values[0]) {
                                fieldItem.values[0] = "";
                            }

                            formChange(field, fieldItem.values[0], productOptionsContainer, fields, productsToAdd, settings, div);

                            var formDataJson = $(productOptionsContainer.closest("form")).serializeArray();

                            applyFormChangeToImageCustomizer($, formDataJson)


                        }

                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    }


    function applyFormChangeToImageCustomizer($, formData) {
        //fix formData
        var newFormData = [];

        $.each(formData, function (i, value) {
            if (value.name.startsWith("properties[")) {
                var name = value.name.replace("properties[", "");
                name = name.replace("]", "");

                newFormData[name] = value.value;
            }
        });

        var imageCustomizers = $(".product-options-image-customizer");

        $.each(imageCustomizers, function (index, div) {
            var productID = $(div).attr("data-product-id");
            var jsonStructure = window.productImageCustomizer[productID];

            var container = $(div);

            if (jsonStructure) {

                if (!jsonStructure.hiddenOnLoad) {
                    //$('.po-customizer-tabs a:first-child').trigger("click");
                    //$('.po-customizer-tabs a:first-child').addClass("tab-active");
                    const w3Tab = document.querySelector('.po-customizer-tabs a:first-child');
                    if (w3Tab != null) {
                        w3Tab.click();
                    }

                }

                $.each(jsonStructure.layers, function (i, layer) {
                    var imageForLayer = findImageUsedForLayer($, layer, newFormData)
                    //hide all images for this layer
                    var images = container.find("[data-customizer-layer-id='" + layer.layerID + "']");
                    images.addClass("customizer-layer-hidden");

                    images.removeClass("customizer-layer-shown");
                    images.removeClass("customizer-layer-showing");

                    if (imageForLayer != null) {

                        //show this one
                        var image = container.find("[data-customizer-image-id='" + imageForLayer + "']");

                        image.removeClass("customizer-layer-hidden");
                        image.addClass("customizer-layer-showing");

                        var srcAttr = image.attr("src");

                        if (typeof srcAttr == typeof undefined || srcAttr == false) {
                            image.attr("src", image.attr("data-src"));
                        }

                        container.find("img[data-customizer-layer-id='" + layer.layerID + "']").load(function () {
                            var img2 = $(this);

                            if (img2.hasClass("customizer-layer-showing")) {
                                img2.addClass("customizer-layer-shown");
                                img2.removeClass("customizer-layer-showing")
                            }

                            resizeImageCustomizer($, container);
                        });
                    }

                });
            }

        });
    }

    function findImageUsedForLayer($, layer, formData) {
        var imageToShowName = null;
        var imageID = null;

        $.each(layer.imagesShown, function (i, image) {
            var imageApplies = true;

            //if the image had no option values selected what to do? is this even possible?
            //if problems maybe look here
            if (image.optionValues.length == 0) {
                imageApplies = false;
            }

            $.each(image.optionValues, function (i, optionValue) {
                if (formData[optionValue.fieldName] !== optionValue.fieldValue) {
                    imageApplies = false;
                }
            });

            if (imageApplies) {
                imageToShowName = image.name;
            }
        });

        //find image id
        $.each(layer.images, function (i, image) {
            if (image.name == imageToShowName) {
                imageID = image.imageID;
            }
        });

        return imageID;

    }

    function resizeImageCustomizer($, container) {

        //auto set height
        var biggestHeight = 0;
        var smallestNatrualWidth = 5000;

        //only check visible images
        container.children(".option-customizer-base-layer,.customizer-layer-shown").each(function () {
            if ($(this).height() > biggestHeight) {
                biggestHeight = $(this).height();
            }

            if ($(this)[0].naturalWidth < smallestNatrualWidth) {
                smallestNatrualWidth = $(this)[0].naturalWidth;
            }
        });


        if (smallestNatrualWidth > 1200) {
            smallestNatrualWidth = 1200;
        }

        //fix max width to match smallest image
        container.children("img").each(function () {
            var element = $(this);

            element.css("max-width", smallestNatrualWidth + "px");
        });


        container.css("max-width", smallestNatrualWidth + "px");



        // Set the container height
        if (!container.hasClass("zoom-mode"))
            container.height(biggestHeight);
    }


    //load image customizer

    var productUrl = location.protocol + '//' + location.host + location.pathname + ".json";

    if (productUrl.indexOf("/products/") != -1) {
        $.ajax({
            method: "GET",
            url: productUrl,
            dataType: "jsonp",
            success: function (data) {
                var product = data.product;

                if (product) {
                    loadImageCustomizers($, product);
                }

            },
            error: function (xhr, text, error) {
                console.log(error);
            }
        });
    }



    function installIntoThemes($, product) {
        if ($(".product-options-image-customizer").length > 0) {
            return; //its already manually installed, lets skip auto installing it
        }

        if ($(".w3-product-options").length == 0) { //doesn't work without po widget
            return;
        }

        var theme = Shopify.theme.theme_store_id;

        if (window.poImageCustomizerThemeID) {
            theme = poImageCustomizerThemeID;
        }

        var widget = "<div class='product-options-image-customizer' data-product-id='" + product.id + "'></div>"
        var tabWrapper =
            "<div class='po-customizer-tab-wrapper'>" +
            "<div class='po-customizer-tab-content'>" +
            "<div class='live-preview-tab'>" +
            widget +
            "</div>" +
            "</div>" +
            "<div class='po-customizer-tabs'>" +
            "<a href='#tab-1' class='po-customizer-tab-1 tab-active'><img src='" + domainUrl + "/images/live-preview.svg' /><span>Live Preview</span></a>" +
            "<a href='#tab-2' class='po-customizer-tab-2'><img src='" + domainUrl + "/images/photos.svg' /><span>Product Photos</span></a>" +
            "</div>" +
            "</div>";

        //this setting only works on debut and parallax so far. You need to change append to prepend for it to work
        if (window.poImageCustomzerTabsOnTop == true) {
            tabWrapper =
                "<div class='po-customizer-tab-wrapper'>" +
                "<div class='po-customizer-tabs'>" +
                "<a href='#tab-1' class='po-customizer-tab-1 tab-active'><img src='" + domainUrl + "/images/live-preview.svg' /><span>Live Preview</span></a>" +
                "<a href='#tab-2' class='po-customizer-tab-2'><img src='" + domainUrl + "/images/photos.svg' /><span>Product Photos</span></a>" +
                "</div>" +
                "<div class='po-customizer-tab-content'>" +
                "<div class='live-preview-tab'>" +
                widget +
                "</div>" +
                "</div>" +
                "</div>";
        }


        if (theme == 796) { //debut
            $(".product-single__photos").children().addClass("existing-slider");

            if (window.poImageCustomzerTabsOnTop == true) {
                $(".product-single__photos").prepend(tabWrapper);
            } else {
                $(".product-single__photos").append(tabWrapper);
            }

        } else if (theme == 719) {//Pop
            $(".product-single > .grid-item:first-child").children().addClass("existing-slider");

            $(".product-single > .grid-item:first-child").append(tabWrapper);

        } else if (theme == 730) {//Brooklyn
            $(".product-single__photos").children().addClass("existing-slider");

            $(".product-single__photos").append(tabWrapper);
        } else if (theme == 679) { //Supply
            $(".product-photo-container").parent().children().addClass("existing-slider");

            $(".product-photo-container").parent().append(tabWrapper);
        } else if (theme == 380) {//Minimal
            $(".product-single__hero .post-large--one-half").first().children().addClass("existing-slider");

            $(".product-single__hero .post-large--one-half").first().append(tabWrapper);
        } else if (theme == 775) {//Venture
            $(".product-single > .grid__item:first-child").children().addClass("existing-slider");

            $(".product-single > .grid__item:first-child").append(tabWrapper);
        } else if (theme == 578) {//Simple
            $(".product-single > .grid__item:first-child").children().addClass("existing-slider");

            $(".product-single > .grid__item:first-child").append(tabWrapper);
        } else if (theme == 766) {//Boundless
            //boundless sucks so it doesn't get an auto installer because the HTML is very messy
            $(".product .product__details").prevAll(".product__photo").addClass("existing-slider");

            $(".product .product__details").before(tabWrapper);

            $(".po-customizer-tab-wrapper").addClass("grid__item");

            $(".product-options-image-customizer").css("margin", "0 auto");


            $(".product-options-image-customizer").addClass("theme-width-limit");
        } else if (theme == 829) {//Narrative
            $(".product__image-container").parent().children().addClass("existing-slider");

            $(".product__image-container").parent().append(tabWrapper);

            $(".product-options-image-customizer").addClass("theme-width-limit");


            $(".product-options-image-customizer").css("margin", "0 auto");
        } else if (theme == 782) {//Jumpstart
            $(".product__image.grid__item").children().addClass("existing-slider");

            $(".product__image.grid__item").append(tabWrapper);
        } else if (theme == 855) {//Prestige NOT FREE
            $(".Product__Gallery").children().addClass("existing-slider");

            $(".Product__Gallery").append(tabWrapper);
        } else if (theme == 838) {//Empire NOT FREE
            $(".product-gallery--overlay").prevAll().addClass("existing-slider");

            $(".product-gallery--overlay").before(tabWrapper);

        } else if (theme == 857) {//Impulse NOT FREE

            $(".product__photos").parent().children().addClass("existing-slider");

            $(".product__photos").parent().append(tabWrapper);
        } else if (theme == 735) {//District NOT FREE

            $(".product-images").children().addClass("existing-slider");

            $(".product-images").append(tabWrapper);
        } else if (theme == 623) {//Testament NOT FREE

            $(".product-photos").children().addClass("existing-slider");

            $(".product-photos").append(tabWrapper);

            $(".po-customizer-tab-wrapper").addClass("desktop-12 tablet-12");

            //mobile
            $(".mobile-gallery").children().addClass("existing-slider");

            $(".mobile-gallery").append(tabWrapper);

        } else if (theme == 847) {//Motion NOT FREE
            $(".product__photos").parent().children().addClass("existing-slider");

            $(".product__photos").parent().append(tabWrapper);
        } else if (theme == 688) {//Parallax

            $(".product_gallery").parent().children().addClass("existing-slider");

            if (window.poImageCustomzerTabsOnTop == true) {
                $(".product_gallery").parent().prepend(tabWrapper);
            } else {
                $(".product_gallery").parent().append(tabWrapper);
            }


        } else if (theme == 606) {//Blockshop
            $(".product-page--images").children().addClass("existing-slider");
            $(".product-page--thumbs").addClass("existing-slider");

            $(".product-page--images").append(tabWrapper);
        } else if (theme == 836) {//Venue
            $(".container > .product-single__photo").parent().children().addClass("existing-slider");

            $(".container > .product-single__photo").parent().append(tabWrapper);

            $(".product-options-image-customizer").css("margin", "0 auto");
            $(".product-options-image-customizer").addClass("theme-width-limit");
        } else if (theme == 739) { //Pipeline
            $(".product__slides").parent().children().addClass("existing-slider");

            $(".product__slides").parent().append(tabWrapper);
        } else if (theme == 686) {//Icon

            $(".product-photos").children().addClass("existing-slider");

            $(".product-photos").append(tabWrapper);

            $(".po-customizer-tab-wrapper").addClass("desktop-12 tablet-12");

        } else if (theme == 567) { //Mr Parker
            $(".product-left").children().addClass("existing-slider");

            $(".product-left").append(tabWrapper);


        } else if (theme == 568) {//Symmetry
            $(".gallery").addClass("existing-slider");
            $(".gallery").after(tabWrapper);

            $(".po-customizer-tab-wrapper").addClass("layout-column-half-left");

            $(".po-customizer-tab-wrapper").css("clear", "both");

        } else if (theme == 411) { //Envy
            $(".product-images").addClass("existing-slider");
            $(".product-images").after(tabWrapper);

            $(".po-customizer-tab-wrapper").addClass("col-md-7");

        }


        $(".existing-slider").hide();
        $(".live-preview-tab").show();

        //hookup tab buttons
        $(".po-customizer-tabs a").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            var a = $(this);

            var href = a.attr("href");

            $(".po-customizer-tabs a").removeClass("tab-active");
            a.addClass("tab-active");


            if (href == "#tab-1") {
                $(".live-preview-tab").show();
                $(".existing-slider").hide();
                resizeImageCustomizer($, $(".product-options-image-customizer"));
            } else {
                $(".live-preview-tab").hide();
                $(".existing-slider").show();

                //fixes lazy loaded sliders
                window.dispatchEvent(new Event('resize'));
            }

        });
    }


    function loadImageCustomizers($, product) {
        //var imageCustomizers = $(".product-options-image-customizer");
        window.productImageCustomizer = window.productImageCustomizer || {};

        var shopName = Shopify.shop.replace(".myshopify.com", "");
        var s3Path = "https://s3.amazonaws.com/product-options-image-customizer/" + shopName + "/";

        var productID = product.id;

        $.ajax({
            method: "GET",
            url: domainUrl + "/api/imagecustomizer?productID=" + productID + "&shopName=" + shopName,
            dataType: "jsonp",
            success: function (data) {

                if (data.imageCustomizerID) { // was there even a customizer for this product?
                    window.productImageCustomizer[productID] = data;


                    installIntoThemes($, product);

                    if (data.hiddenOnLoad == true) {
                        $(".product-options-image-customizer").hide();
                        $(".po-customizer-tab-wrapper").hide();
                        $(".existing-slider").show();

                        $(".po-customizer-wrapper").hide(); //you could reuse this on any elements for custom stuff
                    }

                    function is_touch_device() {
                        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
                        var mq = function (query) {
                            return window.matchMedia(query).matches;
                        }

                        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
                            return true;
                        }

                        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
                        // https://git.io/vznFH
                        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
                        return mq(query);
                    }

                    //setup hover zoom
                    var noZoom = $(".product-options-image-customizer").hasClass("no-zoom");

                    if (!is_touch_device() && !noZoom) {

                        var imgNaturalWidth = 0;

                        $(".product-options-image-customizer").mousemove(function (e) {
                            if ($(".product-options-image-customizer img").first().length) {
                                imgNaturalWidth = $(".product-options-image-customizer img").first()[0].naturalWidth;
                            }

                            //dont zoom if the zoom will do nothing because the container is the same size as the large image
                            if (imgNaturalWidth <= $(".product-options-image-customizer").width()) {
                                return;
                            }

                            $(".product-options-image-customizer").addClass("zoom-mode");

                            var parentOffset = $(this).offset();

                            var naturalWidth = $(".product-options-image-customizer img").width();
                            var naturalHeight = $(".product-options-image-customizer img").height();

                            var overSizeX = $(this).width() / naturalWidth;

                            var overSizeY = $(this).height() / naturalHeight;

                            var relX = ((e.pageX - parentOffset.left) / $(this).width());
                            var relY = ((e.pageY - parentOffset.top) / $(this).width());

                            var pixelX = relX * naturalWidth * (1 - overSizeX);
                            var pixelY = relY * naturalHeight * (1 - overSizeY);

                            $(".product-options-image-customizer .option-customizer-layer").css("left", -pixelX + "px");
                            $(".product-options-image-customizer .option-customizer-layer").css("top", -pixelY + "px");
                            $("body").css("cursor", "zoom-in");
                        });

                        $(".product-options-image-customizer").mouseout(function () {
                            $(".product-options-image-customizer").removeClass("zoom-mode");

                            $(".product-options-image-customizer .option-customizer-layer").css("left", "");
                            $(".product-options-image-customizer .option-customizer-layer").css("top", "");
                            $("body").css("cursor", "");
                        });
                    }

                    $.each($(".product-options-image-customizer"), function (index) {
                        var div = $(this);

                        if (div.hasClass("loaded")) {
                            return;
                        }

                        div.addClass("loaded");

                        //add base image if exists
                        if (data.baseImagePath) {
                            var baseImg = $("<img />");
                            baseImg.attr("data-sort-order", "-1");
                            baseImg.attr("src", s3Path + data.baseImagePath);
                            baseImg.addClass("option-customizer-layer option-customizer-base-layer");
                            baseImg.css("z-index", "0");
                            div.append(baseImg);

                        }


                        //add all the images
                        $.each(data.layers, function (i, layer) {
                            $.each(layer.images, function (i, image) {
                                var imagePath = s3Path + image.imagePath;

                                var layerImage = $("<img />");
                                layerImage.attr("data-customizer-image-id", image.imageID);
                                layerImage.attr("data-customizer-layer-id", layer.layerID);
                                layerImage.attr("data-sort-order", layer.sortOrder);
                                layerImage.attr("data-src", imagePath);
                                layerImage.addClass("option-customizer-layer customizer-layer-hidden");
                                layerImage.css("z-index", layer.sortOrder);

                                div.append(layerImage);

                            });
                        });

                        div.find("img").load(function () {

                            setTimeout(function () {
                                resizeImageCustomizer($, div);
                            }, 5)

                        });

                        //resize on window resize
                        function resizedw() {
                            setTimeout(function () {
                                resizeImageCustomizer($, div);
                            }, 5)
                        }

                        var doit;
                        $(window).resize(function () {
                            clearTimeout(doit);
                            doit = setTimeout(resizedw, 100);
                        });

                        if (window.poPreviousformSelection) {
                            if ($(".w3-product-options-form").length > 0) {
                                var formDataJson = $(".w3-product-options-form").serializeArray();

                                applyFormChangeToImageCustomizer($, formDataJson);
                            }


                        }

                    });



                }

            }
        });


    }

    function isShopifyAnalyticsHandlerBound($, formTag) {
        var ireturn = false;

        try {
            if ($._data($(formTag).get(0), "events").submit) {
                $.each($._data($(formTag).get(0), "events").submit, function (i, submitter) {
                    if (submitter.handler) {
                        if (submitter.handler.toString().indexOf("w3-product-options") != -1) {
                            return; //w3 handler is BEFORE this handler so it won't fire the analytics;
                        }

                        if (submitter.handler.toString().indexOf("ShopifyAnalytics") != -1) {
                            ireturn = true;
                        }
                    }
                });
            }
        } catch (e) {
        }

        return ireturn;
    }

    function generateField(field, productOptionsContainer, fields, productsToAdd, settings) {



        var div = $("<div data-field-id='" + field.id + "' data-group-id='" + field.fieldGroupID + "' data-name='" + field.name + "' class='product-options-control-container' data-tip='' data-group-name='" + (field.settings.group ? field.settings.group : "") + "' data-mode='bottom'></div>");

        if (field.settings.cssClasses != null) {
            div.addClass(field.settings.cssClasses)
        }

        if (field.hidden == false) {
            div.append(field.html);
        }

        setupColorpicker(div, field, productOptionsContainer, fields, productsToAdd, settings);
        setupImagepicker(div, field, productOptionsContainer, fields, productsToAdd, settings);
        setupTextpicker(div, field, productOptionsContainer, fields, productsToAdd, settings);

        setPreloadSetters(field, div);

        return div;
    }

    function setPreloadSetters(field, div) {

        if (field.type == "textbox" || field.type == "textarea" || field.type == "number" || field.type == "date" ) {

            //find input to get value
            var input = div.find("input,textarea");

            field.setPreloadValue = function (values) {
                input.val(values[0]);
            }

        } else if (field.type == "dropdown") {

            var input = div.find("select.product-options-dropdown");

            field.setPreloadValue = function (values) {
                input.val(values[0]);
            }

        } else if (field.type == "checkbox") {
            var input = div.find("input[type='hidden']");

            field.setPreloadValue = function (values) {

                var values = values[0].split(",");

                $.each(values, function (i) {
                    var v = values[i];

                    div.find("input[value='" + v.trim() + "']").attr("checked", "checked");
                });
            }

        } else if (field.type == "radiobutton") {

            field.setPreloadValue = function (values) {

                if (values[0]) {
                    var v = values[0];

                    div.find("input[value='" + v + "']").attr("checked", "checked");
                }
            }
        } else if (field.type == "length") {

            var input = div.find("select.length-val");

            field.setPreloadValue = function (values) {
                input.val(values[0]);
            }

        }else if (field.type == "area") {
            var wInput = div.find("select.width-val");
            var hInput = div.find("select.height-val");

            field.setPreloadValue = function (values) {
                if (values.length == 2) {
                    wInput.val(values[0]);
                    hInput.val(values[1]);
                }
            }

        }
    }

    function checkForRequiredFields(divContainer, fields, language) {
        var errors = [];
        var errorsJson = [];

        divContainer.find(".product-options-control-container").each(function () {
            var id = $(this).data('field-id');
            var field = getField(id, fields);

            if ($(this).children().length != 0) {
                if (field.required == true) {

                    if ($(this).find(".product-options-checkbox").length > 0) {
                        if ($(this).find(".product-options-checkbox:checked").length == 0) {
                            errors.push("<span data-error-field-id='" + field.id + "' data-error-group-id='" + field.fieldGroupID + "'>" + field.name + " " + language.IsRequiredText + "</span>");
                            var obj = {
                                field_id: field.id,
                                group_id: field.fieldGroupID,
                                name: field.name,
                                message: language.IsRequiredText
                            }
                            errorsJson.push(obj);
                        }
                    } else if ($(this).find(".product-options-radiobutton").length > 0) {
                        if ($(this).find(".product-options-radiobutton:checked").length == 0) {
                            errors.push("<span data-error-field-id='" + field.id + "' data-error-group-id='" + field.fieldGroupID + "'>" + field.name + " " + language.IsRequiredText + "</span>");
                            var obj = {
                                field_id: field.id,
                                group_id: field.fieldGroupID,
                                name: field.name,
                                message: language.IsRequiredText
                            }
                            errorsJson.push(obj);
                        }
                    } else if (field.type == 'fileupload') {
                        var fileUploads = $(this).find("input");

                        var hasValue = false;

                        $.each(fileUploads, function () {
                            if ($(this).val() != '') {
                                hasValue = true;

                                return false;
                            }
                        });

                        if (hasValue == false) {
                            errors.push("<span data-error-field-id='" + field.id + "' data-error-group-id='" + field.fieldGroupID + "'>" + field.name + " " + language.IsRequiredText + "</span>");
                            var obj = {
                                field_id: field.id,
                                group_id: field.fieldGroupID,
                                name: field.name,
                                message: language.IsRequiredText
                            }
                            errorsJson.push(obj);
                        }

                    } else if (field.type == 'area') {
                        if ($(this).find("input.width-val").val() == '' || $(this).find("input.height-val").val() == '') {
                            errors.push("<span data-error-field-id='" + field.id + "' data-error-group-id='" + field.fieldGroupID + "'>" + field.name + " " + language.IsRequiredText + "</span>");
                            var obj = {
                                field_id: field.id,
                                group_id: field.fieldGroupID,
                                name: field.name,
                                message: language.IsRequiredText
                            }
                            errorsJson.push(obj);
                        }
                    } else if (field.type == 'length') {
                        if ($(this).find("input.length-val").val() == '') {
                            errors.push("<span data-error-field-id='" + field.id + "' data-error-group-id='" + field.fieldGroupID + "'>" + field.name + " " + language.IsRequiredText + "</span>");
                            var obj = {
                                field_id: field.id,
                                group_id: field.fieldGroupID,
                                name: field.name,
                                message: language.IsRequiredText
                            }
                            errorsJson.push(obj);
                        }

                    } else {
                        if ($(this).find("input, select, textarea").val() == '') {
                            errors.push("<span data-error-field-id='" + field.id + "' data-error-group-id='" + field.fieldGroupID + "'>" + field.name + " " + language.IsRequiredText + "</span>");
                            var obj = {
                                field_id: field.id,
                                group_id: field.fieldGroupID,
                                name: field.name,
                                message: language.IsRequiredText
                            }
                            errorsJson.push(obj);
                        }
                    }
                }

                if (field.type == "fileupload") {
                    if (typeof w3SupportedFormats != "undefined") {
                        var supportedFormats = w3SupportedFormats;
                        //var supportedFormats = ['psd', 'gif', 'png', 'eps', 'jpg', 'jpeg', 'tiff', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'mp3', 'wav', 'csv', 'stl', 'constructioninfo'];
                        $.each($(this).find("input"), function () {

                            if ($(this).val() != '') {
                                var ext = $(this).val().split('.').pop().toLowerCase();

                                if ($.inArray(ext, supportedFormats) == -1) {
                                    errors.push("<span data-error-field-id='" + field.id + "' data-error-group-id='" + field.fieldGroupID + "'>" + field.name + " has an invalid file type.</span>");
                                    var obj = {
                                        field_id: field.id,
                                        group_id: field.fieldGroupID,
                                        name: field.name,
                                        message: "invalid file type"
                                    }
                                    errorsJson.push(obj);
                                    return false;
                                }
                            }

                        });
                    }
                }
            }
        });

        //check for min qty
        var mainQty = divContainer.closest("form").find("input[name='quantity'][data-min-qty]");

        if (mainQty.length > 0) {
            var minValue = mainQty.attr("data-min-qty");

            var value = parseInt(mainQty.val());
            if (isNaN(value)) {
                value = 1;
            }

            if (value < minValue) {
                errors.push(language.MinimumQuantityRequired + minValue)
                var obj = {
                    field_id: null,
                    group_id: null,
                    name: "form",
                    message: language.MinimumQuantityRequired + minValue
                }
                errorsJson.push(obj);
            }
        }

        document.querySelector('body').dispatchEvent(new CustomEvent('productOptionsValidationErrors', { bubbles: true, cancelable: true, detail: [errorsJson] }));
        return errors;
    }


    function setupImagepicker(div, field, productOptionsContainer, fields, productsToAdd, settings) {
        if (field.type == 'imagepicker') {


            field.setPreloadValue = function (values) {

                var values2 = values[0].split(",");

                $.each(values2, function (i) {
                    var v = values2[i];

                    div.find(".image-picker-item[data-name='" + v + "']").addClass("imagepicker-selected");
                });

                div.find("input[type='hidden']").first().val(values2);

            }

            div.find(".product-options-imagepicker-container .image-picker-item > div.tip > img").on("touchstart mousedown", function (e) {
                if (e.type == "mousedown" && e.which != 1) {
                    return; //down handle anything except for left click on desktop
                }

                var aTag = $(this).closest(".image-picker-item");

                var aTagHadClassAlready = false;

                if (!field.settings.allowMultipleSelection) {
                    aTagHadClassAlready = aTag.hasClass("imagepicker-selected");
                    aTag.closest('.imagepicker-items').find(".imagepicker-selected").removeClass("imagepicker-selected");
                    aTag.find(".fields-shown").empty();
                }

                if (aTag.hasClass("imagepicker-selected")) {
                    aTag.removeClass("imagepicker-selected");
                    aTag.find(".fields-shown").empty();
                } else {
                    if (!aTagHadClassAlready) {
                        aTag.addClass("imagepicker-selected");
                    }
                }



                var names = [];
                var descriptions = [];

                $.each(aTag.parent().find(".imagepicker-selected"), function () {
                    names.push($(this).data("name"));
                    descriptions.push($(this).find(".imagepicker-desc").html());
                });

                aTag.closest(".product-options-imagepicker-container").find("input[type='hidden']").first().val(names.join(","));

                var items = [];

                aTag.closest(".product-options-imagepicker-container").find(".imagepicker-selected").each(function () { items.push($(this).data("name")); });

                value = items;

                //show descriptions
                aTag.closest(".product-options-imagepicker-container").find(".imagepicker-descriptions").empty();
                $.each(descriptions, function (i, desc) {
                    var text = "<div class='desc-wrapper'>" + desc + "</div>"

                    aTag.closest(".product-options-imagepicker-container").find(".imagepicker-descriptions").append(text);
                });


                formChange(field, value, productOptionsContainer, fields, productsToAdd, settings, div);

                var formDataJson = $(aTag.closest("form")).serializeArray();

                applyFormChangeToImageCustomizer($, formDataJson)


                e.preventDefault();

            });


            setTimeout(function () {
                $('.image-picker-item .tip').tipr({
                    'mode': 'top'
                });
            }, 0);

        }

    }


    function setupTextpicker(div, field, productOptionsContainer, fields, productsToAdd, settings) {
        if (field.type == 'textpicker') {

            field.setPreloadValue = function (values) {

                var values2 = values[0].split(",");

                $.each(values2, function (i) {
                    var v = values2[i];

                    div.find(".product-options-textpicker[data-name='" + v + "']").addClass("textpicker-selected");
                });

                div.find("input[type='hidden']").first().val(values2);
            }


            div.find(".product-options-textpicker").on("touchstart mousedown", function (e) {
                var aTag = $(this);

                var aTagHadClassAlready = false;

                if (!field.settings.allowMultipleSelection) {
                    aTagHadClassAlready = aTag.hasClass("textpicker-selected");

                    aTag.parent().find(".product-options-textpicker.textpicker-selected").removeClass("textpicker-selected");
                }

                if (aTag.hasClass("textpicker-selected")) {
                    aTag.removeClass("textpicker-selected");
                } else {
                    if (!aTagHadClassAlready) {
                        aTag.addClass("textpicker-selected");
                    }
                }


                var names = [];

                $.each(aTag.parent().find(".product-options-textpicker.textpicker-selected"), function () {
                    names.push($(this).data("name"));
                });

                aTag.parent().find("input").val(names.join(","));


                var items = [];

                aTag.parent().find(".product-options-textpicker.textpicker-selected").each(function () { items.push($(this).data("value")); });

                value = items;

                formChange(field, value, productOptionsContainer, fields, productsToAdd, settings, div);

                var formDataJson = $(aTag.closest("form")).serializeArray();

                applyFormChangeToImageCustomizer($, formDataJson)

                e.preventDefault();

            });


        }
    }


    function setupColorpicker(div, field, productOptionsContainer, fields, productsToAdd, settings) {
        if (field.type == 'colorpicker') {

            field.setPreloadValue = function (values) {

                var values2 = values[0].split(",");

                $.each(values2, function (i) {
                    var v = values2[i];

                    div.find(".product-options-colorpicker[data-name='" + v + "']").addClass("colorpicker-selected");
                });

                div.find("input[type='hidden']").first().val(values2);
            }


            div.find(".product-options-colorpicker").on("touchstart mousedown", function (e) {
                var aTag = $(this);

                var aTagHadClassAlready = false;

                if (!field.settings.allowMultipleSelection) {
                    aTagHadClassAlready = aTag.hasClass("colorpicker-selected");

                    aTag.parent().find(".product-options-colorpicker.colorpicker-selected").removeClass("colorpicker-selected");
                }

                if (aTag.hasClass("colorpicker-selected")) {
                    aTag.removeClass("colorpicker-selected");
                } else {
                    if (!aTagHadClassAlready) {
                        aTag.addClass("colorpicker-selected");
                    }
                }


                var names = [];

                $.each(aTag.parent().find(".product-options-colorpicker.colorpicker-selected"), function () {
                    names.push($(this).data("name"));
                });

                aTag.parent().find("input").val(names.join(","));


                var items = [];

                aTag.parent().find(".product-options-colorpicker.colorpicker-selected").each(function () { items.push($(this).data("value")); });

                value = items;

                formChange(field, value, productOptionsContainer, fields, productsToAdd, settings, div);

                var formDataJson = $(aTag.closest("form")).serializeArray();

                applyFormChangeToImageCustomizer($, formDataJson)

                e.preventDefault();

            });

            $('.options-tip').tipr({
                'mode': 'top'
            });
        }
        /*
        if (field.type == 'dropdown') {

            div.find(".product-options-control").on('blur', function () {
                var value = div.find(".product-options-control").val();

                console.log("asdjasd");

                formChange(field, value, productOptionsContainer, fields, productsToAdd);
            });
            
        }*/
    }

    function escapeSingleQuote(value) {
        value = value.replace(/'/g, "\\'");
        //console.log(value);
        return value;
    }

    function findAreaProductToAdd(fieldId, productsToAdd) {
        var returnI = -1;

        $.each(productsToAdd, function (i, v) {
            if (v.area) {
                if (v.field == fieldId) {
                    returnI = i;
                }
            }
        });
        return returnI;
    }


    function formChange(field, value, productOptionsContainer, fields, productsToAdd, settings, target) {
        if ($.poDebug) {
            console.log("formChange()");
            console.log(field);
            console.log(value);
        }

        if (field.type == "area") {
            var areaSettings = {
                widthLabel: 'Width',
                heightLabel: 'Height',
                widthMin: 1,
                widthMax: 100,
                heightMin: 1,
                heightMax: 100,
                chargeExtra: false,
                priceBreaks: []
            };

            if (field.values.length > 0) {
                $.extend(areaSettings, JSON.parse(field.values[0]));
            }

            if (areaSettings.chargeExtra && areaSettings.variantId) {

                var widthSelect = target.find(".product-options-area-col").first().find("select.product-options-control");
                var heightSelect = target.find(".product-options-area-col").last().find("select.product-options-control");

                var width = widthSelect.val();
                var height = heightSelect.val();

                if (width && height) {
                    var area = width * height;
                    var adjustedArea = width * height;

                    var qtyMultiplier = 1;
  
                    $.each(areaSettings.priceBreaks, function (i, priceBreak) {
                        if (area >= priceBreak.min && area <= priceBreak.max) {
                            qtyMultiplier = priceBreak.quantityMultiplier;
                            if (priceBreak.adjustment) {
                                if (priceBreak.adjustment != 0 && priceBreak.adjustment != "") {
                                    adjustedArea = area + priceBreak.adjustment;
                                    if (adjustedArea < 0) {
                                        adjustedArea = 0;
                                    }
                                }
                            }
                           
                        }
                    });

                    var existingIndex = findAreaProductToAdd(field.id, productsToAdd);

                    if (existingIndex != -1) {
                        productsToAdd.splice(existingIndex, 1);
                    }

                    if (qtyMultiplier > 0) {
                        productsToAdd.push({
                            id: areaSettings.productId,
                            variantId: areaSettings.variantId,
                            handle: areaSettings.handle,
                            field: field.id,
                            fieldDiv: target,
                            area: adjustedArea,
                            qtyMultiplier: qtyMultiplier
                        });
                    }

                    productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                } else {
                    var existingIndex = findAreaProductToAdd(field.id, productsToAdd);

                    if (existingIndex != -1) {
                        productsToAdd.splice(existingIndex, 1);

                        productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                    }

                }
            }

        }

        if (field.type == "length") {
            var lengthSettings = {
                lengthMin: 1,
                lengthMax: 100,
                chargeExtra: false,
                priceBreaks: []
            };

            if (field.values.length > 0) {
                $.extend(lengthSettings, JSON.parse(field.values[0]));
            }

            if (lengthSettings.chargeExtra && lengthSettings.variantId) {

                var lengthSelect = target.find("select");

                var length = lengthSelect.val();

                if (length) {

                    var qtyMultiplier = 1;

                    $.each(lengthSettings.priceBreaks, function (i, priceBreak) {
                        if (length >= priceBreak.min && length <= priceBreak.max) {
                            qtyMultiplier = priceBreak.quantityMultiplier;
                        }
                    });

                    //will find areaproducttoadd work?
                    var existingIndex = findAreaProductToAdd(field.id, productsToAdd);

                    if (existingIndex != -1) {
                        productsToAdd.splice(existingIndex, 1);
                    }

                    if (qtyMultiplier > 0) {
                        productsToAdd.push({
                            id: lengthSettings.productId,
                            variantId: lengthSettings.variantId,
                            handle: lengthSettings.handle,
                            field: field.id,
                            fieldDiv: target,
                            area: length,
                            qtyMultiplier: qtyMultiplier
                        });
                    }

                    productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                } else {
                    var existingIndex = findAreaProductToAdd(field.id, productsToAdd);

                    if (existingIndex != -1) {
                        productsToAdd.splice(existingIndex, 1);

                        productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                    }

                }
            }

        }


        $.each(field.logic, function (index1, logic) {
            var rulesValid = false;
            var ruleEvals = [];

            if (Array.isArray(value) == false) {
                $.each(logic.rules, function (index2, rule) {

                    if (field.type == "date") {
                        var today = new Date();
                        var myDate = null;
                        var compareDate = null;

                        var sDate = rule.value.toLowerCase();
                        sDate = sDate.replace("/", "-");

                        if (sDate == '{today}') {
                            //date is today
                            myDate = Date.parse(value);
                            compareDate = Date.parse(today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate());
                            ruleEvals.push(myDate + " " + rule.operator + " " + compareDate);

                        } else if (sDate == '{sunday}' || sDate == '{monday}' || sDate == '{tuesday}' || sDate == '{wednesday}' || sDate == '{thursday}' || sDate == '{friday}' || sDate == '{saturday}') {
                            var selDate = moment(value, 'YYYY-MM-DD').toDate();
                            myDate = selDate.getDay();
                            switch (sDate) {
                                case '{sunday}':
                                    compareDate = 0;
                                    break;
                                case '{monday}':
                                    compareDate = 1;
                                    break;
                                case '{tuesday}':
                                    compareDate = 2;
                                    break;
                                case '{wednesday}':
                                    compareDate = 3;
                                    break;
                                case '{thursday}':
                                    compareDate = 4;
                                    break;
                                case '{friday}':
                                    compareDate = 5;
                                    break;
                                case '{saturday}':
                                    compareDate = 6;
                                    break;
                                default:
                                // code block
                            }

                            ruleEvals.push(myDate + " " + rule.operator + " " + compareDate);

                        } else if (sDate.includes('{today:')) {
                            //add days
                            sDate = sDate.replace("{today:", "");
                            sDate = sDate.replace("}", "");
                            var sDateAdd = sDate.split(" ");

                            compareMoment = moment().add(sDateAdd[0], sDateAdd[1]);
                            myDate = Date.parse(value);
                            compareDate = Date.parse(compareMoment.format('YYYY') + "-" + compareMoment.format('MM') + "-" + compareMoment.format('DD'))

                            ruleEvals.push(myDate + " " + rule.operator + " " + compareDate);

                        } else if (sDate.includes('*') && sDate.includes('-')) {
                            var selDate = moment(value, 'YYYY-MM-DD').toDate();
                            var sDateParts = sDate.split("-");
                            if (sDateParts[0] != "*") {
                                //year
                                myDate = selDate.getFullYear();
                                compareDate = parseInt(sDateParts[0]);
                                ruleEvals.push(myDate + " " + rule.operator + " " + compareDate);
                            }
                            if (sDateParts[1] != "*") {
                                //month
                                myDate = selDate.getMonth() + 1;
                                compareDate = parseInt(sDateParts[1]);
                                ruleEvals.push(myDate + " " + rule.operator + " " + compareDate);
                            }
                            if (sDateParts[2] != "*") {
                                //day
                                myDate = selDate.getDate();
                                compareDate = parseInt(sDateParts[2]);
                                ruleEvals.push(myDate + " " + rule.operator + " " + compareDate);
                            }

                        } else if (sDate.includes('-')) {
                            myDate = Date.parse(value);
                            var selDate = moment(sDate, 'YYYY-MM-DD').toDate();
                            compareDate = Date.parse(selDate.getFullYear() + "-" + (selDate.getMonth() + 1) + "-" + selDate.getDate());
                            ruleEvals.push(myDate + " " + rule.operator + " " + compareDate);
                        }


                    } else {
                        ruleEvals.push("'" + escapeSingleQuote(value) + "' " + rule.operator + " '" + escapeSingleQuote(rule.value) + "'");
                    }
                    
                });
            } else {
                $.each(logic.rules, function (index2, rule) {
                    if (rule.operator == "==") {
                        ruleEvals.push("'|" + escapeSingleQuote(value.join("| |")) + "|'.indexOf('|" + escapeSingleQuote(rule.value) + "|') != -1");
                    } else {
                        ruleEvals.push("'|" + escapeSingleQuote(value.join("| |")) + "|'.indexOf('|" + escapeSingleQuote(rule.value) + "|') == -1");
                    }
                });
            }



            if (ruleEvals.length > 0) {

                if (logic.andOr == "or") {
                    rulesValid = eval(ruleEvals.join(" || "));

                    if ($.poDebug) {
                        console.log(ruleEvals.join(" || "));
                    }
                } else {
                    rulesValid = eval(ruleEvals.join(" && "));

                    if ($.poDebug) {
                        console.log(ruleEvals.join(" && "));
                    }
                }
            } else {
                rulesValid = true;
            }

            if (rulesValid) {

                //do all the actions in order
                $.each(logic.actions, function (index3, action) {


                    if (action.type == "show") {


                        var div = productOptionsContainer.find("[data-field-id='" + action.id + "']");

                        var actionField = getField(action.id, fields);

                        if (div.children().length == 0) {
                            div.html(actionField.html);

                            //move div under imagepicker value if setting enable
                            if (field.settings.showConditionalLogicUnderImage) {
                                if (Array.isArray(value)) {
                                    if (logic.rules.length == 1) {
                                        var value2 = logic.rules[0].value;

                                        var parentDiv = productOptionsContainer.find("[data-field-id='" + field.id + "'] [data-name='" + value2 + "'] .fields-shown").first();

                                        if (parentDiv.children("[data-field-id='" + action.id + "']").length == 0) {
                                            div.appendTo(parentDiv);

                                            var orig = div.clone();
                                            orig.empty();
                                            orig.appendTo(productOptionsContainer);
                                        }

                                        
                                    } else {
                                        //doesn't really work with multiple logics (or 0)
                                    }
                                } else {
                                    var parentDiv = productOptionsContainer.find("[data-field-id='" + field.id + "'] [data-name='" + value + "'] .fields-shown").first();
                                    div.appendTo(parentDiv);
                                }

                            }

                            if (div.closest(".po-accordion-group").length > 0) {
                                div.closest(".po-accordion-group").show();
                            }

                            actionField.elementDiv = div;

                            setPreloadSetters(actionField, div);

                            fieldAdded(actionField, div, productOptionsContainer, fields, productsToAdd, settings);

                            div.data("shown-by", action.actionId);

                            setupColorpicker(div, actionField, productOptionsContainer, fields, productsToAdd, settings);
                            setupImagepicker(div, actionField, productOptionsContainer, fields, productsToAdd, settings);
                            setupTextpicker(div, actionField, productOptionsContainer, fields, productsToAdd, settings);



                        } else {
                            div.data("shown-by", action.actionId);
                        }
                    }

                    if (action.type == "hide") {
                        var div = productOptionsContainer.find("[data-field-id='" + action.id + "']");

                        var actionField = getField(action.id, fields);

                        div.data("hidden-by", action.actionId);

                        div.empty();

                        formChange(actionField, '', productOptionsContainer, fields, productsToAdd, settings, div);
                    }

                    if (action.type == "show-group") {
                        var shownByField = productOptionsContainer.find("[data-field-id='" + field.id + "']");

                        var fieldGroupID = action.id;

                        var existingAsync = productOptionsContainer.find(".async-field-group[data-shown-by=" + action.actionId + "]");

                        if (existingAsync.length) { //it was already shown by this specific action
                            return;
                        }

                        shownByField.after("<div class='fields-loading'>Loading...</div>");

                        $.ajax({
                            method: "GET",
                            url: domainUrl + "/api/productwidget?shopName=" + Shopify.shop + "&fieldGroupID=" + fieldGroupID,
                            dataType: "jsonp",
                            success: function (data) {
                                productOptionsContainer.find(".fields-loading").remove();

                                var asyncWrapper = null;

                                if (data.fields.length > 0) {
                                    asyncWrapper = $("<div class='async-field-group'></div>");
                                    shownByField.after(asyncWrapper);

                                    asyncWrapper.attr("data-shown-by", action.actionId);
                                    asyncWrapper.attr("data-sort", data.sort_order);


                                    shownByField.parent().find('.async-field-group').sortElements(function (a, b) {
                                        return parseInt($(a).attr("data-sort")) > parseInt($(b).attr("data-sort")) ? 1 : -1;
                                    });
                                }

                                $.each(data.fields, function (i, field) {

                                    field.shownByAction = action.actionId;
                                    fields.push(field);

                                    var div = generateField(field, productOptionsContainer, fields, productsToAdd, settings);

                                    asyncWrapper.append(div);

                                    if (field.hidden == false) {
                                        field.elementDiv = div;


                                        setPreloadSetters(field, div);

                                        fieldAdded(field, div, productOptionsContainer, fields, productsToAdd, settings);
                                    }
                                });
                            }
                        });
                    }

                    if (action.type == "product") {
                        //console.log("action.type == product")
                        var productAlreadyAdded = false;


                        $.each(productsToAdd, function (index) {

                            if (productsToAdd[index].action == action.actionId && productsToAdd[index].fieldDiv[0] == target[0]) {
                                productAlreadyAdded = true;

                                return false;
                            }
                        });

                        if (!productAlreadyAdded) {
                            if (action.selectedProduct) {
                                productsToAdd.push({
                                    id: action.selectedProduct.id,
                                    variantId: action.selectedProduct.variantId,
                                    handle: action.selectedProduct.handle,
                                    field: field.id,
                                    fieldDiv: target,
                                    action: action.actionId
                                });

                                productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                            } else {
                                console.log("conditional logic trying to add blank product:");
                                console.log(action);
                            }

                        }

                    }

                    if (action.type == "show-customizer") {
                        $(".product-options-image-customizer").show();
                        $(".po-customizer-tab-wrapper").show();
                        $(".existing-slider").hide();

                        $(".po-customizer-wrapper").show(); //you could reuse this on any elements for custom stuff

                        window.dispatchEvent(new Event('resize'));
                    }

                    if (action.type == "show-popup") {

                        $.magnificPopup.close();

                        if (action.data) {
                            $.magnificPopup.open({
                                items: {
                                    src: action.data,
                                    type: 'iframe'
                                }
                            });
                        } else {
                            $.magnificPopup.open({
                                items: {
                                    src: '<div style="color:#fff;">You did not seem to specifiy a URL for the popup to show. Please update the your Product Options conditional logic</span>',
                                    type: 'inline'
                                }
                            });
                        }
                    }

                    if (action.type == "show-popup-image") {

                        $.magnificPopup.close();

                        if (action.data) {
                            $.magnificPopup.open({
                                items: {
                                    src: action.data,
                                    type: 'image'
                                }
                            });
                        } else {
                            $.magnificPopup.open({
                                items: {
                                    src: '<div style="color:#fff;">You did not seem to specifiy a URL for the popup to show. Please update the your Product Options conditional logic</span>',
                                    type: 'inline'
                                }
                            });
                        }
                    }

                    if (action.type == "min-qty") {
                        var qty = parseInt(action.data);

                        if (!isNaN(qty)) {
                            var mainQty = productOptionsContainer.closest("form").find("input[name='quantity']");

                            if (mainQty.length > 0) {
                                mainQty.attr("data-min-qty", qty);

                                if (mainQty.val() < qty) {
                                    mainQty.val(qty);
                                }
                            }
                        }
                    }

                });
            } else {
                //do the opposite of the actions

                $.each(logic.actions, function (index3, action) {
                    if (action.type == "show") {

                        var div = productOptionsContainer.find("[data-field-id='" + action.id + "']");

                        var actionField = getField(action.id, fields);

                        if (actionField.hidden) {

                            if (typeof (div.data("shown-by")) != 'undefined') {
                                var shownBy = div.data("shown-by");

                                if (shownBy == action.actionId) {
                                    div.empty();
                                    div.removeData("shown-by");
                                    formChange(actionField, '', productOptionsContainer, fields, productsToAdd, settings, div);

                                    //hide accordion if empty
                                    if (div.closest(".po-accordion-group").length > 0) {
                                        var empty = true;

                                        $.each(div.closest(".po-accordion-group").children(".product-options-control-container"), function () {
                                            if ($(this).children().length > 0) {
                                                empty = false;
                                            }
                                        });

                                        if (empty) {
                                            div.closest(".po-accordion-group").hide();
                                        }
                                    }


                                }
                            }

                        }
                    }

                    if (action.type == "hide") {
                        var div = productOptionsContainer.find("[data-field-id='" + action.id + "']");

                        var actionField = getField(action.id, fields);

                        if (actionField.hidden != true) {
                            if (div.children().length == 0) {
                                if (typeof (div.data("hidden-by")) != 'undefined') {
                                    var hiddenBy = div.data("hidden-by");

                                    if (hiddenBy == action.actionId) {
                                        div.append(actionField.html);

                                        actionField.elementDiv = div;

                                        setPreloadSetters(actionField, div);

                                        fieldAdded(actionField, div, productOptionsContainer, fields, productsToAdd, settings);
                                    }
                                }

                                setupColorpicker(div, actionField, productOptionsContainer, fields, productsToAdd, settings);
                                setupImagepicker(div, actionField, productOptionsContainer, fields, productsToAdd, settings);
                                setupTextpicker(div, actionField, productOptionsContainer, fields, productsToAdd, settings);

                            }
                        }
                    }

                    if (action.type == "show-group") {
                        var asyncFieldsDiv = productOptionsContainer.find(".async-field-group[data-shown-by=" + action.actionId + "]");


                        //fix products to add
                        var nestedFields = asyncFieldsDiv.find(".product-options-control-container");

                        var productsChanged = false;

                        $.each(nestedFields, function (i, nestedField) {

                            for (var x = productsToAdd.length - 1; x >= 0; x--) {

                                if (nestedField == productsToAdd[x].fieldDiv[0]) {
                                    productsToAdd.splice(x, 1);

                                    productsChanged = true;
                                }
                            }
                        });

                        if (productsChanged) {
                            productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                        }

                        //clear div
                        asyncFieldsDiv.remove();

                        //remove data objects from fields JS object
                        for (var i = fields.length - 1; i >= 0; i--) {
                            var field = fields[i];

                            if (field.shownByAction == action.actionId) {
                                fields.splice(i, 1);
                            }
                        }


                    }

                    if (action.type == "product") {
                        var indexToRemove = -1;

                        $.each(productsToAdd, function (index) {
                            if (productsToAdd[index].action == action.actionId) {
                                indexToRemove = index;

                                return false;
                            }
                        });

                        //console.log("remove product at index: " + indexToRemove);

                        if (indexToRemove != -1) {
                            productsToAdd.splice(indexToRemove, 1);

                            productsToAddChanged(productsToAdd, productOptionsContainer, settings);
                        }


                    }

                    if (action.type == "show-customizer") {
                        $(".product-options-image-customizer").hide();
                        $(".po-customizer-tab-wrapper").hide();
                        $(".existing-slider").show();

                        $(".po-customizer-wrapper").hide(); //you could reuse this on any elements for custom stuff
                    }

                    if (action.type == "min-qty") {

                        var mainQty = productOptionsContainer.closest("form").find("input[name='quantity']");

                        if (mainQty.length > 0) {
                            mainQty.removeAttr("data-min-qty");
                        }


                    }

                });
            }
        });




    };


    var cartLookupLastCalled = Date.now();

    var xhr = null;
    var cachedProductLookups = [];
    var savedHandles = {};

    function productsToAddChanged(productsToAdd, productOptionsContainer, settings) {
        if (!productOptionsContainer.find(".product-options-price-info").length) {
            productOptionsContainer.append("<div class='product-options-price-info'></div>");
        }

        var pricingInfoDiv = productOptionsContainer.find(".product-options-price-info");

        if (productsToAdd.length == 0) {
            pricingInfoDiv.hide();

            $('body').trigger("productOptionsPriceChange", [0, productOptionsContainer, []]);
            document.querySelector('body').dispatchEvent(new CustomEvent('productOptionsPriceChangeJS', { bubbles: true, cancelable: true, detail: [0, productOptionsContainer, []] }));


            return;
        }

        var quantity = 1;

        //main item qty
        var mainQty = productOptionsContainer.closest("form").find("input[name='quantity']");
        var optionsUnlinked = productOptionsContainer.closest("form").find("input[name='_options_unlink']").length > 0;


        if (optionsUnlinked) {
            quantity = 1;
        } else {
            if (mainQty.length > 0 && $.isNumeric(mainQty.val())) {
                quantity = parseInt(mainQty.val());
            }
        }
        /*
        $.each(productsToAdd, function (index, value) {
            console.log(value.handle);

            productPricingRequest.products.push({
                productID: value.id,
                variantID: value.variantId
            })
        });
        */

        var requests = [];

        if (!Promise.allSettled) {
            return;
        }

        var handlesByIndex = [];

        $.each(productsToAdd, function (i, prod) {
            if (prod.handle && !savedHandles[prod.handle]) {
                requests.push($.ajax({
                    type: "GET",
                    url: '/products/' + prod.handle + ".js",
                    dataType: "json"
                }));

                handlesByIndex.push(prod.handle);
            }

        });

        if (requests.length == 0) {//all were cached
            renderPricing(productsToAdd);
        }

        Promise.allSettled(requests).then(function (promiseResults) {

            $.each(promiseResults, function (i2, promiseResult) {

                if (promiseResult.status == "fulfilled" && promiseResult.value) {



                    savedHandles[promiseResult.value.handle] = promiseResult.value;

                } else {
                    console.log(promiseResult);

                    //check if its a 404
                    if (promiseResult.status == "rejected" && promiseResult.reason && promiseResult.reason.status == 404) {
                        //lets try to see if there is a 301

                        var xhr;
                        var _orgAjax = $.ajaxSettings.xhr;
                        $.ajaxSettings.xhr = function () {
                            xhr = _orgAjax();
                            return xhr;
                        };


                        $.ajax({
                            type: "GET",
                            url: '/products/' + handlesByIndex[i2],
                            success: function (data, textStatus, jqXHR) {
                                //console.log(data);

                                if (jqXHR.status == 200) {
                                    //IE11 doesn't support responseURL, and no alternative exists
                                    var newUrl = xhr.responseURL;

                                    if (newUrl) {
                                        $.ajax({
                                            type: "GET",
                                            url: newUrl + ".js",
                                            dataType: "json",
                                            success: function (data, textStatus, jqXHR) {
                                                console.log(jqXHR);
                                                if (jqXHR.status == 200) {
                                                    savedHandles[handlesByIndex[i2]] = data;

                                                    renderPricing(productsToAdd);
                                                }

                                            }
                                        });
                                    }

                                }


                            }
                        })
                    }
                }

            });


            renderPricing(productsToAdd);

        });

        function renderPricing(productsToAdd) {
            if (productsToAdd.length == 0) {
                pricingInfoDiv.hide();

                $('body').trigger("productOptionsPriceChange", [0, productOptionsContainer, []]);
                document.querySelector('body').dispatchEvent(new CustomEvent('productOptionsPriceChangeJS', { bubbles: true, cancelable: true, detail: [0, productOptionsContainer, []] }));


                return;
            }

            pricingInfoDiv.empty();
            pricingInfoDiv.append("<div class='pricing-info-header'>" + settings.language.AdditionalCostHeading + "</div>");

            var pricingTotal = 0;

            if (pricingInfoDiv.find(".pricing-info-products").length == 0) {
                pricingInfoDiv.append("<div class='pricing-info-products'></div>")
            }

            var productTitlesDiv = pricingInfoDiv.find(".pricing-info-products");

            var products = [];


            $.each(productsToAdd, function (i2, prodToAdd) {
                var product = savedHandles[prodToAdd.handle];

                if (product) {

                    var variant = product.variants.filter(function (v) { return v.id == prodToAdd.variantId })[0];
                    var title = product.title;

                    if (variant) {
                        product.variant_id = prodToAdd.variantId;
                        product.variantID = prodToAdd.variantId;

                        products.push(product);

                        var pricingInfoProduct = $("<div class='pricing-info-product'></div>");


                        if (variant.title != "Default Title" && variant.title != "" && variant.title != "Default") {
                            title = title + " - " + variant.title;
                        }

                        pricingInfoProduct.append("<div class='pricing-info-product-title'>" + title + "</div>");

                        productTitlesDiv.append(pricingInfoProduct);


                        //var price = variant.price;

                        if (prodToAdd.area) {

                            if (productOptionsContainer.closest("form").hasClass("w3-po-no-qty-mult")) {
                                pricingTotal += (variant.price / 100) * prodToAdd.area;
                            } else {
                                pricingTotal += (variant.price / 100) * prodToAdd.area * prodToAdd.qtyMultiplier;
                            }



                        } else {
                            pricingTotal += (variant.price / 100);
                        }


                    } else {
                        console.log("PO pricing variant not found");
                        console.log("Handles");
                        if (savedHandles) {
                            console.log(savedHandles);
                        }
                        console.log("prodToAdd");
                        if (prodToAdd) {
                            console.log(prodToAdd);
                        }
                        console.log("Found prod");
                        if (product) {
                            console.log(product);
                        }
                        console.log("variant ID");
                        if (prodToAdd.variantId) {
                            console.log(prodToAdd.variantId);
                        }
                    }
                }

            });


            //set price total in div

            var price = pricingTotal * 100;

            if (!productOptionsContainer.closest("form").hasClass("w3-po-no-qty-mult")) {
                price = price * quantity;
            }


            if (typeof Shopify.formatMoney != "undefined") {
                price = Shopify.formatMoney(price, settings.moneyFormat);
            }

            pricingInfoDiv.find(".pricing-info-total").remove();

            pricingInfoDiv.append("<div class='pricing-info-total'>" + settings.language.TotalAdditionalCost + " <span class='pricing-info-total-price'>" + price + "</span></div>");

            try {
                if (typeof Currency != "undefined") {
                    if (typeof Currency.cookie != "undefined") {
                        if (Currency.cookie.read() != null) {
                            //priceDiv.html(Currency.formatMoney(variant.price, myMoneyFormat));
                            Currency.convertAll(settings.defaultCurrency, Currency.cookie.read(), '.pricing-info-total-price span.money', 'money_format');
                        }
                    }

                }
            } catch (err) {
                //console.log(err);
            }

            //end setting price
            pricingInfoDiv.show();

            $('body').trigger("productOptionsPriceChange", [pricingTotal, productOptionsContainer, products]);
            document.querySelector('body').dispatchEvent(new CustomEvent('productOptionsPriceChangeJS', { bubbles: true, cancelable: true, detail: [pricingTotal, productOptionsContainer, products, productsToAdd] }));



        }


    }

    function getField(id, fields) {
        var field;

        $.each(fields, function (index, value) {

            if (value.id.toString() == id) {
                field = value;
            }
        });

        return field;
    }

    //cart page stuff
    /*
    jQuery(document).ajaxSuccess(function (event, xhr, settings) {
        
        if (settings.dataType == "json" && settings.type == "GET") {
            if (typeof (xhr.responseJSON.items) != 'undefined') {
                fixItems(xhr.responseJSON);
            }
            //console.log(settings);
            //console.log(event);
            //console.log(xhr.responseJSON);
        }
    });*/


    var refreshPage = false;

    var itemQuantities = [];

    let updates = {};

    function fixItems(cart, async, callback) {

        refreshPage = false;         
        updates = {};               
        itemQuantities = [];

        $.each(cart.items, function (index, item) {
            itemQuantities.push(item.quantity);
        });

        $.each(cart.items, function (index, value) {
            if (value.properties != null) {
                if (typeof value.properties['_options_unlink'] == 'undefined') {
                    if (typeof value.properties['_options_hidden'] != 'undefined') {
                        var guid1 = value.properties['_options_group_id'];

                        if (doesMainProductExist(cart, guid1) == false) {
                            itemQuantities[index] = 0;

                            const propName = value.key;
                            updates[propName] = 0;

                            refreshPage = true;
                        } else {
                            var mainItem = getMainProduct(guid1, cart);

                            if (typeof value.properties['_options_qty_mult'] != 'undefined') {
                                var calcQty = mainItem.quantity * parseInt(parseFloat(value.properties['_options_qty_mult']) * parseFloat(value.properties['_options_area']));

                                if (value.quantity != calcQty) {
                                    //need to fix
                                    itemQuantities[index] = calcQty;

                                    const propName = value.key;
                                    updates[propName] = calcQty;

                                    refreshPage = true;
                                }

                            } else {
                                if (mainItem.quantity != value.quantity) {
                                    itemQuantities[index] = mainItem.quantity;

                                    const propName = value.key;
                                    updates[propName] = mainItem.quantity;

                                    refreshPage = true;
                                }
                            }


                        }
                    }

                } else {
                    if (doesMainProductExist(cart, value.properties['_options_group_id']) == false) {
                        itemQuantities[index] = 0;

                        const propName = value.key;
                        updates[propName] = 0;

                        refreshPage = true;
                    } else {
                        if (typeof value.properties['_options_hidden'] != 'true' && itemQuantities[index] != 1) {
                            itemQuantities[index] = 1;

                            const propName = value.key;
                            updates[propName] = 1;

                            refreshPage = true;
                        }
                    }
                }
            }
        });

        if (refreshPage == true) {

            window.poPendingRefresh = window.poPendingRefresh || false;

            if ($.poDebug) {
                console.log(itemQuantities);
                console.log(updates);
            }

            $.ajax({
                type: "POST",
                url: "/cart/update.js",
                dataType: 'json',
                data: { updates },
                success: function (data) {
                    if ($.poDebug) {
                        console.log("update complete");
                        console.log(data);
                    }
                    if (async == false) {
                        //window.location.href = window.location.href
                        if (!window.poPendingRefresh) {
                             window.poPendingRefresh = true;
                            setTimeout(function () { window.location.href = window.location.href; }, 50);
                        }

                    } else {
                        if (typeof (callback) != "undefined") {
                            callback(data);
                        }
                    }

                },
                error: function (data) {
                    if (data.statusText == "parsererror") {
                        if (async == false) {
                            //window.location.href = window.location.href
                            if (!window.poPendingRefresh) {
                                window.poPendingRefresh = true;
                                setTimeout(function () { window.location.href = window.location.href; }, 50);
                            }
                        } else {
                            if (typeof (callback) != "undefined") {
                                callback(data);
                            }
                        }

                    } else {
                        if ($.poDebug) {
                            console.log("update error");
                            console.log(data);
                        }
                    }

                }
            });
        } else {
            if (async == true) {
                if (typeof (callback) != "undefined") {
                    callback();
                }
            }
        }

    }

    function getMainProduct(guid1, cart) {
        var ireturn;

        $.each(cart.items, function (index, value) {
            if (value.properties != null) {
                if (typeof value.properties['_options_group_id'] != 'undefined') {
                    if (typeof value.properties['_options_hidden'] == 'undefined') {
                        if (value.properties['_options_group_id'].toString() == guid1) {
                            ireturn = value;
                        }
                    }
                }
            }
        });

        return ireturn;
    }

    function doesMainProductExist(cart, guid1) {
        var ireturn = false;

        $.each(cart.items, function (index, value) {
            if (value.properties != null) {
                if (typeof value.properties['_options_group_id'] != 'undefined') {
                    if (typeof value.properties['_options_hidden'] == 'undefined') {
                        if (value.properties['_options_group_id'].toString() == guid1) {
                            ireturn = true;
                            return ireturn;
                        }
                    }
                }
            }
        });

        return ireturn;
    }

    function fieldAdded(field, element, productOptionsContainer, fields, productsToAdd, settings) {

        if (typeof fieldAddedCallback != "undefined") {
            if (fieldAddedCallback.length) {
                fieldAddedCallback(field, element);
            }
        }

        setTimeout(function () {
            loadPreSelections(field, productOptionsContainer, fields, productsToAdd, settings, element)

        }, 10)

        if (productOptionsContainer.find('.product-options-price-info').length > 0) {
            productOptionsContainer.find('.product-options-price-info').appendTo(productOptionsContainer)
        }

        element.find(".po-field-name-tooltip").tipr({
            'mode': 'top'
        });
    }

    $(".options-hidden").hide();

};


function W3LoadScript(url, callback) {

    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState) {  //IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" ||
                script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

function loadProductOptionsLibrary() {
    if (!window.moment) {
        var script = document.createElement("script")
        script.type = "text/javascript";
        script.src = "//cdnjs.cloudflare.com/ajax/libs/moment.js/2.30.1/moment.js";
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    if (isVersionBad()) {
        W3LoadScript('//ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', function () {
            var jQueryPrivate = jQuery.noConflict(true);

            jQueryPrivate(function () {
                setTimeout(function () {
                    w3productOptionsJS(jQueryPrivate);
                }, 5);
            });

        });
    } else {

        jQuery(function () {
            setTimeout(function () {
                w3productOptionsJS(jQuery);
            }, 5);
        });


    }
}

function isVersionBad() {
    if (typeof jQuery === 'undefined') {
        return true;
    }

    var version = jQuery.fn.jquery.split('.');
    var major = parseInt(version[0]);
    var minor = parseInt(version[1]);

    // Accept jQuery 1.8+, 2.x, and 3.x+. Only fall back when the page's
    // jQuery is too old to reliably run this app (1.7 or below).
    if (major >= 2) {
        return false;
    }

    if (major == 1 && minor < 8) {
        return true;
    }

    return false;
}



loadProductOptionsLibrary();

function optionsGenerateGuid() {
    var result, i, j;
    result = '';
    for (j = 0; j < 32; j++) {
        if (j == 8 || j == 12 || j == 16 || j == 20)
            result = result + '-';
        i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
        result = result + i;
    }
    return result;
}
} // end of __w3ProductOptionsLoaded guard